(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3983],{

/***/ 10150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3789);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68527);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14257);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4612);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51419);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_startCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18029);
/* harmony import */ var lodash_startCase__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_startCase__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87536);
/* harmony import */ var components_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11665);
/* harmony import */ var constants_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88501);









var FormItem = function(props) {
    var name = props.name, label = props.label, _type = props.type, type = _type === void 0 ? "text" : _type, placeholder = props.placeholder, _isRequired = props.isRequired, isRequired = _isRequired === void 0 ? true : _isRequired, children = props.children, helperText = props.helperText, readonly = props.readonly, disabled = props.disabled, hideLabel = props.hideLabel, className = props.className, errorClassName = props.errorClassName, inputColor = props.inputColor, min = props.min, width = props.width, height = props.height, autoComplete = props.autoComplete, hideErrorMessage = props.hideErrorMessage, _whiteSpace = props.whiteSpace, whiteSpace = _whiteSpace === void 0 ? false : _whiteSpace, defaultValue = props.defaultValue;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useFormContext */ .Gc)(), register = ref.register, errors = ref.formState.errors, control = ref.control;
    var pattern;
    switch(name){
        case "firstName":
        case "lastName":
        case "previousLandlordName":
            //*INFO: validate name, allow only letters, spaces, special characters like - ' and not allow icon
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .NAME_WITH_NUMBER_PATTERN */ .Jp,
                message: "Please enter a valid name"
            };
            break;
        case "email":
        case "previousLandlordEmail":
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .EMAIL_PATTERN */ .QI,
                message: "Please enter a valid email"
            };
            break;
        case "dateOfBirth":
            //*INFO: validate (MM/DD/YYYY), with a year between 1900 and 2099
            pattern = {
                value: /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/,
                message: "Please enter a valid date"
            };
            break;
        case "zipCode":
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .ZIP_CODE_PATTERN */ .fY,
                message: "Please enter a valid zip code"
            };
            break;
        case "vrTourUrl":
            pattern = {
                value: /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
                message: "Invalid URL"
            };
            break;
        case "monthlyIncome":
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .MONTHLY_INCOME_PATTERN */ .ZI,
                message: "Please enter a valid monthly income"
            };
            break;
        case "previousLandlordPhoneNumber":
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .RAW_PHONE_NUMBER_PATTERN */ .kc,
                message: "Please enter a valid phone number"
            };
            break;
        default:
            pattern = undefined;
    }
    var disabledProps = disabled ? {
        disabled: true,
        background: "gray.100",
        opacity: "0.7 !important",
        color: "gray.400",
        variant: "filled"
    } : {};
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .FormControl */ .NI, {
        isInvalid: !!lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(errors, name, false),
        alignSelf: !label || hideLabel ? "flex-end" : undefined,
        className: className,
        width: width,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .HStack */ .Ug, {
                spacing: "14px",
                maxHeight: 6,
                marginBottom: label ? 2 : 0,
                position: "relative",
                children: [
                    label && !hideLabel && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .FormLabel */ .lX, {
                        whiteSpace: whiteSpace ? "nowrap" : "normal",
                        color: "gray.700",
                        lineHeight: 6,
                        marginBottom: 0,
                        marginInlineEnd: 0,
                        minWidth: "200px",
                        children: label
                    }),
                    helperText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Tooltip */ .u, {
                        label: helperText,
                        hasArrow: true,
                        placement: "right",
                        background: "gray.900",
                        color: "white",
                        fontSize: "sm",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                            textAlign: "center",
                            height: "20px",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(components_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                iconName: "information_line_blue.svg",
                                size: 20
                            })
                        })
                    })
                ]
            }),
            children ? children : type !== "number" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Input */ .II, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                height: height,
                type: type,
                autoComplete: autoComplete !== null && autoComplete !== void 0 ? autoComplete : name,
                placeholder: placeholder,
                isReadOnly: readonly,
                color: inputColor
            }, disabledProps, register(name, {
                required: isRequired ? "".concat(label !== null && label !== void 0 ? label : lodash_startCase__WEBPACK_IMPORTED_MODULE_1___default()(name), " is required") : false,
                pattern: pattern
            }))) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .Controller */ .Qr, {
                name: name,
                control: control,
                rules: {
                    required: true
                },
                render: function(param) {
                    var field = param.field;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .NumberInput */ .Y2, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        defaultValue: defaultValue,
                        focusBorderColor: "teal.500"
                    }, field), {
                        min: min,
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .NumberInputField */ .zu, {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .NumberInputStepper */ .Fi, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .NumberIncrementStepper */ .WQ, {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .NumberDecrementStepper */ .Y_, {})
                                ]
                            })
                        ]
                    }));
                }
            }),
            !hideErrorMessage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .FormErrorMessage */ .J1, {
                className: errorClassName,
                children: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(errors, "".concat(name, ".message"), "")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormItem);


/***/ }),

/***/ 11665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);




var Icon = function(props) {
    var iconName = props.iconName, size = props.size, alt = props.alt, width = props.width, height = props.height, className = props.className, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave;
    var defaultSize = 32;
    var iconSize = size ? size : defaultSize;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: "/assets/icons/".concat(iconName),
        alt: alt,
        unoptimized: true,
        loading: "eager",
        width: width || iconSize,
        height: height || iconSize,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, "is-clickable", onClick)),
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 23983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./enums/common/index.ts
var common = __webpack_require__(71074);
// EXTERNAL MODULE: ./enums/featureFlags/index.ts
var featureFlags = __webpack_require__(9322);
// EXTERNAL MODULE: ./hooks/useFeatureFlagValue.ts
var useFeatureFlagValue = __webpack_require__(45949);
// EXTERNAL MODULE: ./hooks/useStores.ts
var useStores = __webpack_require__(19263);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js
var mobxreact_esm = __webpack_require__(29323);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./API/error.ts
var API_error = __webpack_require__(76214);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./routes/index.ts + 2 modules
var routes = __webpack_require__(1179);
// EXTERNAL MODULE: ./utils/common.ts
var utils_common = __webpack_require__(6628);
;// CONCATENATED MODULE: ./components/Footer/constants.ts

var usefullLinks = {
    title: "Useful Links",
    links: [
        {
            link: "https://livehomeroom.com/podcasts",
            text: "Podcasts & News"
        },
        {
            link: "https://livehomeroom.com/team",
            text: "Team"
        },
        {
            link: "https://livehomeroom.com/contact-us",
            text: "Contact Us"
        },
        {
            link: "https://livehomeroom.com/blog",
            text: "Blog"
        },
        {
            link: "https://livehomeroom.com/careers",
            text: "Careers at HomeRoom"
        },
        {
            link: "https://livehomeroom.com/registered-investment-advisor",
            text: "For Investment Advisors"
        },
        {
            link: "https://livehomeroom.com/affiliates",
            text: "Affiliate Program"
        },
        {
            link: "https://livehomeroom.com/privacy-policy",
            text: "Privacy Policy"
        },
        {
            link: "https://livehomeroom.com/terms-of-service",
            text: "Terms of Service"
        }
    ]
};
var realEstateInvestors = {
    title: "Real Estate Investors",
    links: [
        {
            link: "https://livehomeroom.com/homeroom-intro",
            text: "Talk to the Investments Team"
        },
        {
            link: "https://livehomeroom.com/invest-with-homeroom",
            text: "Investor Purchase Process"
        },
        {
            link: "https://livehomeroom.com/financing",
            text: "Partner Lenders"
        },
        {
            link: "https://livehomeroom.com/investor-faq",
            text: "Investor FAQs"
        },
        {
            link: "https://livehomeroom.com/investor-precall-assessment",
            text: "Investor Precall Assessment"
        },
        {
            link: "https://livehomeroom.com/convert-to-coliving",
            text: "Convert to Coliving"
        },
        {
            link: "https://livehomeroom.com/property-onboarding-form",
            text: "Property Onboarding Form"
        }
    ]
};
var renters = {
    title: "Renters",
    links: [
        {
            link: "https://livehomeroom.com/pretour-scheduler",
            text: "Book A Tour"
        },
        {
            link: "https://livehomeroom.com/blog/co-living-connected-theres-an-app-for-that",
            text: "Tenant App on iOS or Android"
        }
    ]
};
var tabletFooterLinks = [
    (0,_object_spread/* default */.Z)({}, usefullLinks),
    (0,_object_spread/* default */.Z)({}, renters)
];
var socialLinks = [
    {
        label: "LinkedIn",
        icon: "linkedin.svg",
        href: "https://www.linkedin.com/company/33219805"
    },
    {
        label: "Facebook",
        icon: "facebook.svg",
        href: "https://www.facebook.com/livehomeroom"
    },
    {
        label: "Instagram",
        icon: "instagram.svg",
        href: "https://www.instagram.com/livehomeroom/"
    },
    {
        label: "Mail",
        icon: "mail.svg",
        href: "mailto:info@livehomeroom.com"
    }
];

;// CONCATENATED MODULE: ./components/Footer/utils.ts




function getLocationsLinks(metroList) {
    var links = (0,utils_common/* getValidArray */._b)(metroList).map(function(metro) {
        var _name;
        return {
            text: "".concat(metro === null || metro === void 0 ? void 0 : metro.name, " ").concat(metro === null || metro === void 0 ? void 0 : metro.state),
            link: "".concat(routes/* default.home.value */.Z.home.value, "?metro=").concat(encodeURIComponent((_name = metro.name) !== null && _name !== void 0 ? _name : ""))
        };
    });
    return links;
}
function getLocationFooterLinks(metroList) {
    return {
        title: "Locations",
        links: getLocationsLinks(metroList)
    };
}
function getTabletFooterLinks(metroList) {
    return [
        (0,_object_spread/* default */.Z)({}, realEstateInvestors),
        (0,_object_spread/* default */.Z)({}, getLocationFooterLinks(metroList))
    ];
}
function getDesktopFooterLinks() {
    return [
        (0,_object_spread/* default */.Z)({}, renters),
        (0,_object_spread/* default */.Z)({}, realEstateInvestors)
    ];
}

// EXTERNAL MODULE: ./components/Icon/index.tsx
var Icon = __webpack_require__(11665);
// EXTERNAL MODULE: ./components/NextLink/index.tsx
var NextLink = __webpack_require__(6538);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js
var chakra_ui_system_esm = __webpack_require__(46052);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js + 1 modules
var chakra_ui_button_esm = __webpack_require__(85054);
// EXTERNAL MODULE: ./utils/chakraShouldForwardProp.ts
var chakraShouldForwardProp = __webpack_require__(8650);
;// CONCATENATED MODULE: ./components/Footer/footer.styles.ts


var Container = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Container */.W2, function() {
    return {
        maxWidth: "1248px",
        paddingY: {
            base: "40px",
            lg: "64px"
        },
        paddingX: 8,
        backgroundColor: "background.primary"
    };
});
var Box = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Box */.xu, function() {
    return {
        display: "flex",
        flexDirection: "row",
        fontSize: "md",
        justifyContent: "center",
        color: "gray.50"
    };
});
var NavigationSection = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: function() {
        return {
            flexDirection: {
                base: "column",
                lg: "row"
            },
            justifyContent: "space-between",
            alignItems: "flex-start"
        };
    }
});
var SocialMedia = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Box */.xu, {
    baseStyle: function() {
        return {
            paddingEnd: "12",
            marginBottom: {
                base: "10",
                lg: 0
            },
            flex: 0
        };
    }
});
var SocialButton = (0,chakra_ui_system_esm/* chakra */.m$)("a", {
    baseStyle: {
        rounded: "lg",
        width: "8",
        height: "8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "blackAlpha.500",
        color: "white",
        transition: "all 0.2s",
        _hover: {
            transition: "all 0.2s",
            backgroundColor: "blackAlpha.900"
        }
    }
});
var FooterColumn = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Box */.xu, function(props) {
    return {
        flexDirection: "column",
        display: (props === null || props === void 0 ? void 0 : props.isShort) ? {
            base: "none",
            md: "flex",
            lg: "none"
        } : "flex"
    };
});
var PrivacySection = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: function() {
        return {
            marginTop: 10,
            flexDirection: {
                base: "column-reverse",
                lg: "row"
            },
            alignItems: {
                base: "flex-start",
                lg: "center"
            },
            justifyContent: "space-between",
            fontSize: "sm"
        };
    }
});
var CommonDivider = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Divider */.iz, {
    baseStyle: function() {
        return {
            marginY: 10,
            borderColor: "rgba(255, 255, 255, 0.24)"
        };
    }
});
var Button = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_button_esm/* Button */.zx, {
    baseStyle: function() {
        return {
            width: "32px",
            minWidth: "32px",
            height: "32px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0
        };
    }
});
var Title = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Text */.xv, function() {
    return {
        color: "white",
        fontWeight: 700,
        fontSize: "xl",
        whiteSpace: "nowrap",
        marginBottom: 6
    };
});
var DropdownButton = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_button_esm/* Button */.zx, {
    baseStyle: function() {
        return {
            fontSize: "xl",
            color: "white",
            justifyContent: "flex-start",
            paddingX: 0,
            height: "28px",
            backgroundColor: "transparent",
            fontWeight: 600,
            cursor: "pointer",
            ":hover": {
                backgroundColor: "transparent",
                color: "teal.100"
            },
            ":active": {
                backgroundColor: "transparent",
                color: "teal.100"
            },
            "&[data-active]": {
                backgroundColor: "transparent",
                color: "teal.100"
            }
        };
    }
});
var Text = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Text */.xv, function(props) {
    return {
        color: "gray.100",
        fontWeight: (props === null || props === void 0 ? void 0 : props.isTitle) ? 700 : 400,
        fontSize: "md",
        whiteSpace: (props === null || props === void 0 ? void 0 : props.isTitle) ? "nowrap" : "normal",
        ":hover": {
            color: "gray.200"
        },
        ":active": {
            color: "gray.300"
        }
    };
});
var TextWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Box */.xu, {
    baseStyle: function() {
        return {
            "&:hover": {
                "& > a > p": {
                    color: "gray.200"
                }
            },
            "&:active": {
                "& > a > p": {
                    color: "gray.300"
                }
            }
        };
    }
});
var Wrap = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Wrap */.Eq, {
    baseStyle: function() {
        return {
            spacing: {
                base: "4",
                lg: "8"
            },
            marginTop: {
                base: "4",
                lg: "0"
            }
        };
    }
});
var NavigationLink = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
    baseStyle: function() {
        return {
            width: "full",
            flex: 1,
            fontSize: "sm"
        };
    }
});

;// CONCATENATED MODULE: ./components/Footer/components/FooterDesktop/index.tsx









var FooterDesktop = function(props) {
    var metroList = props.metroList;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        as: "footer",
        background: "background.primary",
        display: {
            base: "none",
            md: "block"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavigationSection, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavigationLink, {
                            columns: {
                                md: 2,
                                lg: 3
                            },
                            spacing: 10,
                            children: [
                                (0,utils_common/* getValidArray */._b)(tabletFooterLinks).map(function(footer, indexFooter) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Stack */.Kq, {
                                        flexDirection: {
                                            base: "column",
                                            lg: "row"
                                        },
                                        spacing: 8,
                                        display: {
                                            lg: "none"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterColumn, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                                        lineHeight: 7,
                                                        children: footer.title
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Stack */.Kq, {
                                                        as: "ul",
                                                        listStyleType: "none",
                                                        spacing: 4,
                                                        children: (0,utils_common/* getValidArray */._b)(footer.links).map(function(link, index) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                                                as: "li",
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                                                    href: link.link,
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                                        children: link.text
                                                                    })
                                                                })
                                                            }, index);
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterColumn, {
                                                isShort: true,
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                                        lineHeight: 7,
                                                        children: getTabletFooterLinks(metroList)[indexFooter].title
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Stack */.Kq, {
                                                        as: "ul",
                                                        listStyleType: "none",
                                                        spacing: 4,
                                                        children: (0,utils_common/* getValidArray */._b)(getTabletFooterLinks(metroList)[indexFooter].links).map(function(link, index) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWrapper, {
                                                                as: "li",
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                                                    href: link.link,
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                                        children: link.text
                                                                    })
                                                                })
                                                            }, index);
                                                        })
                                                    })
                                                ]
                                            }, "short-".concat(indexFooter))
                                        ]
                                    }, indexFooter);
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Stack */.Kq, {
                                    flexDirection: {
                                        base: "column",
                                        lg: "row"
                                    },
                                    spacing: 8,
                                    display: {
                                        md: "none",
                                        lg: "block"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterColumn, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                                lineHeight: 7,
                                                children: usefullLinks.title
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Stack */.Kq, {
                                                as: "ul",
                                                listStyleType: "none",
                                                spacing: 4,
                                                children: (0,utils_common/* getValidArray */._b)(usefullLinks.links).map(function(link, index) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                                        as: "li",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                                            href: link.link,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                                children: link.text
                                                            })
                                                        })
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Stack */.Kq, {
                                    flexDirection: {
                                        base: "row",
                                        lg: "column"
                                    },
                                    spacing: 8,
                                    display: {
                                        base: "none",
                                        lg: "flex"
                                    },
                                    children: (0,utils_common/* getValidArray */._b)(getDesktopFooterLinks()).map(function(footer, indexFooter) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterColumn, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                                    lineHeight: 7,
                                                    children: footer.title
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Stack */.Kq, {
                                                    as: "ul",
                                                    listStyleType: "none",
                                                    spacing: 4,
                                                    children: (0,utils_common/* getValidArray */._b)(footer.links).map(function(link, index) {
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                                            as: "li",
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                                                href: link.link,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                                    children: link.text
                                                                })
                                                            })
                                                        }, index);
                                                    })
                                                })
                                            ]
                                        }, indexFooter);
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Stack */.Kq, {
                                    flexDirection: {
                                        base: "column",
                                        lg: "row"
                                    },
                                    spacing: 8,
                                    display: {
                                        md: "none",
                                        lg: "block"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterColumn, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                                lineHeight: 7,
                                                children: getLocationFooterLinks(metroList).title
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Stack */.Kq, {
                                                as: "ul",
                                                listStyleType: "none",
                                                spacing: 4,
                                                children: (0,utils_common/* getValidArray */._b)(getLocationFooterLinks(metroList).links).map(function(link, index) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                                        as: "li",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                                            href: link.link,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                                children: link.text
                                                            })
                                                        })
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                            spacing: 8,
                            flex: 0,
                            marginTop: {
                                md: 10,
                                lg: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                                    spacing: 4,
                                    alignItems: "flex-start",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: "mailto:info@livehomeroom.com",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                                spacing: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                        isTitle: true,
                                                        children: "General:"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                        children: "info@livehomeroom.com"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: "mailto:invest@livehomeroom.com",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                                spacing: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                        isTitle: true,
                                                        children: "Investing:"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                        children: "invest@livehomeroom.com"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* HStack */.Ug, {
                                            spacing: 2,
                                            alignItems: "flex-start",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                children: "HomeRoom, Prairie Village, KS 66208, United States"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* HStack */.Ug, {
                                    spacing: 4,
                                    marginTop: 8,
                                    alignSelf: "flex-start",
                                    children: socialLinks.map(function(social) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialButton, {
                                            href: social.href,
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                size: 32,
                                                iconName: social.icon
                                            })
                                        }, social.label);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonDivider, {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box, {
                    children: [
                        "\xa9 Copyright ",
                        dayjs_min_default()().year(),
                        " HomeRoom, Inc."
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_FooterDesktop = (FooterDesktop);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js
var chakra_ui_icons_esm = __webpack_require__(59876);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/chakra-ui-transition.esm.js
var chakra_ui_transition_esm = __webpack_require__(37496);
;// CONCATENATED MODULE: ./components/Footer/components/FooterMobile/index.tsx












var FooterMobile = function(props) {
    var toggleCollapse = function toggleCollapse(index) {
        if (openIndex === index) {
            setOpenIndex(-1);
        } else {
            setOpenIndex(index);
        }
    };
    var ref = (0,react.useState)(-1), openIndex = ref[0], setOpenIndex = ref[1];
    var metroList = props.metroList;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        as: "footer",
        background: "orange.50",
        display: {
            base: "block",
            md: "none"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavigationSection, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationLink, {
                            columns: 1,
                            spacing: 8,
                            children: (0,utils_common/* getValidArray */._b)((0,_to_consumable_array/* default */.Z)(tabletFooterLinks).concat((0,_to_consumable_array/* default */.Z)(getTabletFooterLinks(metroList)))).map(function(footer, indexFooter) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterColumn, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownButton, {
                                            _focus: {
                                                boxShadow: "none"
                                            },
                                            fontSize: 20,
                                            fontWeight: 700,
                                            lineHeight: 7,
                                            rightIcon: openIndex === indexFooter ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* ChevronUpIcon */.g8, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* ChevronDownIcon */.v4, {}),
                                            onClick: function() {
                                                return toggleCollapse(indexFooter);
                                            },
                                            children: footer.title
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_transition_esm/* Collapse */.UO, {
                                            in: openIndex === indexFooter,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Stack */.Kq, {
                                                as: "ul",
                                                listStyleType: "none",
                                                spacing: 4,
                                                marginTop: 6,
                                                children: (0,utils_common/* getValidArray */._b)(footer.links).map(function(link, index) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWrapper, {
                                                        as: "li",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                                            href: link.link,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                                children: link.text
                                                            })
                                                        })
                                                    }, index);
                                                })
                                            })
                                        })
                                    ]
                                }, indexFooter);
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                            spacing: 8,
                            flex: 0,
                            marginTop: 10,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                                    spacing: 4,
                                    alignItems: "flex-start",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: "mailto:info@livehomeroom.com",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                                spacing: 2,
                                                flexWrap: "wrap",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                        isTitle: true,
                                                        children: "General:"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                        children: "info@livehomeroom.com"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: "mailto:invest@livehomeroom.com",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                                spacing: 2,
                                                flexWrap: "wrap",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                        isTitle: true,
                                                        children: "Investing:"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                        children: "invest@livehomeroom.com"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* HStack */.Ug, {
                                            spacing: 2,
                                            alignItems: "flex-start",
                                            flexWrap: "wrap",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                children: "HomeRoom, Prairie Village, KS 66208, United States"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* HStack */.Ug, {
                                    spacing: 4,
                                    marginTop: 8,
                                    alignSelf: "flex-start",
                                    children: socialLinks.map(function(social) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialButton, {
                                            href: social.href,
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                size: 32,
                                                iconName: social.icon
                                            })
                                        }, social.label);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonDivider, {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box, {
                    children: [
                        "\xa9 Copyright ",
                        dayjs_min_default()().year(),
                        " HomeRoom, Inc."
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_FooterMobile = (FooterMobile);

;// CONCATENATED MODULE: ./components/Footer/index.tsx


var Footer = {
    Mobile: components_FooterMobile,
    Desktop: components_FooterDesktop
};
/* harmony default export */ var components_Footer = (Footer);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/chakra-ui-icon.esm.js
var chakra_ui_icon_esm = __webpack_require__(10894);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/chakra-ui-image.esm.js + 1 modules
var chakra_ui_image_esm = __webpack_require__(78428);
// EXTERNAL MODULE: ./enums/theme/index.ts
var theme = __webpack_require__(60431);
// EXTERNAL MODULE: ./hooks/useBreakPoint.ts
var useBreakPoint = __webpack_require__(41894);
;// CONCATENATED MODULE: ./components/Footer/components/BenefitsSection/constant.ts
var benefitList = [
    "Furnished common areas",
    "Kitchen essentials",
    "Smart TV",
    "Utilities split evenly",
    "Easy payment through the app",
    "Improve your credit score with on-time rent payments"
];
var termAndConditionLink = "https://livehomeroom.com/happy-homes";

;// CONCATENATED MODULE: ./components/Footer/components/BenefitsSection/index.tsx








var trialBackground = "/assets/images/30-day-trial.png";
var benefitsSection = "/assets/images/benefits-section.png";
var BenefitsSection = function(props) {
    var handleOpenTermAndCondition = function handleOpenTermAndCondition() {
        window.open(termAndConditionLink, "_blank");
    };
    var ref;
    var _metroWithPricing = props.metroWithPricing, metroWithPricing = _metroWithPricing === void 0 ? {} : _metroWithPricing;
    var isMobile = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.LG */.yE.LG);
    var ref1;
    var serviceFee = (ref1 = metroWithPricing === null || metroWithPricing === void 0 ? void 0 : (ref = metroWithPricing.metroPricing) === null || ref === void 0 ? void 0 : ref.serviceFee) !== null && ref1 !== void 0 ? ref1 : 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        backgroundColor: "#F3EADA",
        paddingX: {
            base: 0,
            lg: 150
        },
        spacing: {
            base: 10,
            lg: 20
        },
        marginTop: {
            base: 0,
            lg: 120
        },
        paddingBottom: {
            base: 10,
            lg: 20
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                flexDirection: {
                    base: "column",
                    lg: "row"
                },
                alignItems: "center",
                backgroundColor: "#FFFAF0",
                gap: 8,
                borderRadius: {
                    base: 0,
                    lg: "8px"
                },
                marginTop: {
                    lg: -120
                },
                paddingY: 10,
                paddingX: {
                    base: 4,
                    md: 8,
                    lg: 10
                },
                maxWidth: {
                    lg: 1140
                },
                children: [
                    !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Img */.Ei, {
                            src: "".concat(trialBackground),
                            maxWidth: 400
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                        alignItems: {
                            base: "center",
                            lg: "flex-start"
                        },
                        spacing: {
                            base: 2,
                            lg: 6
                        },
                        width: "full",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                fontSize: {
                                    base: "xl",
                                    lg: "4xl"
                                },
                                lineHeight: {
                                    base: 7,
                                    lg: "44px"
                                },
                                fontWeight: 700,
                                textAlign: {
                                    base: "center",
                                    lg: "left"
                                },
                                children: [
                                    "Happy Homes - ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_system_esm/* chakra.span */.m$.span, {
                                        color: "teal.500",
                                        children: "30-Day Test Run"
                                    })
                                ]
                            }),
                            isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Flex */.kC, {
                                paddingY: 2,
                                justifyContent: {
                                    base: "center",
                                    lg: "unset"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Img */.Ei, {
                                    src: "".concat(trialBackground),
                                    maxWidth: 250
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                                spacing: {
                                    base: 2,
                                    lg: 4
                                },
                                alignItems: {
                                    base: "center",
                                    lg: "flex-start"
                                },
                                width: "full",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                        fontSize: {
                                            base: "md",
                                            lg: "lg"
                                        },
                                        lineHeight: {
                                            base: 6,
                                            lg: 7
                                        },
                                        textAlign: {
                                            base: "center",
                                            lg: "left"
                                        },
                                        children: [
                                            "Here at ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                                                children: "HomeRoom"
                                            }),
                                            ",",
                                            "we're confident you'll adore your new living space and housemates! However, we\n              understand that every situation is unique."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                        fontSize: {
                                            base: "md",
                                            lg: "lg"
                                        },
                                        lineHeight: {
                                            base: 6,
                                            lg: 7
                                        },
                                        textAlign: {
                                            base: "center",
                                            lg: "left"
                                        },
                                        children: "That's why we provide alternatives if you decide it's not a perfect fit within 30 days of your move-in.\n              Relocate to another available HomeRoom home and find your perfect fit.*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                                spacing: 0,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                    fontSize: "sm",
                                    lineHeight: 5,
                                    fontWeight: 500,
                                    color: "teal.500",
                                    cursor: "pointer",
                                    onClick: handleOpenTermAndCondition,
                                    children: "* Click here to read Terms and conditions."
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                gap: {
                    lg: 8
                },
                width: "full",
                alignItems: {
                    base: "center",
                    lg: "flex-start"
                },
                flexDirection: {
                    base: "column",
                    lg: "row"
                },
                justifyContent: {
                    base: "center",
                    lg: "unset"
                },
                paddingX: {
                    base: 4,
                    md: 8,
                    lg: 0
                },
                maxWidth: {
                    lg: 1140
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                        spacing: {
                            base: 4,
                            lg: 6
                        },
                        maxWidth: {
                            lg: 700
                        },
                        width: "full",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                                spacing: {
                                    base: 0,
                                    lg: 4
                                },
                                alignItems: "flex-start",
                                width: "full",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                        fontSize: {
                                            base: "lg",
                                            lg: "4xl"
                                        },
                                        lineHeight: {
                                            base: 7,
                                            lg: "44px"
                                        },
                                        fontWeight: 700,
                                        color: "teal.500",
                                        children: "Numerous Advantages!"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                        fontSize: {
                                            base: "lg",
                                            lg: "4xl"
                                        },
                                        lineHeight: {
                                            base: 7,
                                            lg: "44px"
                                        },
                                        fontWeight: 700,
                                        children: [
                                            "All encompassed in a single $",
                                            serviceFee,
                                            " monthly charge"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                                        spacing: 0,
                                        alignItems: "flex-start",
                                        width: "full",
                                        paddingTop: {
                                            base: 4,
                                            lg: 0
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                            fontSize: {
                                                base: "md",
                                                lg: "lg"
                                            },
                                            lineHeight: {
                                                base: 6,
                                                lg: 7
                                            },
                                            children: [
                                                "Our goal is to ensure an exceptional living experience for you and your housemates. The $",
                                                serviceFee,
                                                " ",
                                                "per month* flat rate for services includes:"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                                alignItems: "flex-start",
                                width: "full",
                                paddingY: {
                                    base: 2,
                                    lg: 4
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                                    columns: 1,
                                    gap: {
                                        base: 2,
                                        lg: 4
                                    },
                                    children: (0,utils_common/* getValidArray */._b)(benefitList).map(function(benefit, index) {
                                        if (!benefit) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                            spacing: {
                                                base: 2,
                                                lg: 4
                                            },
                                            alignItems: "flex-start",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icon_esm/* Icon */.JO, {
                                                    bg: "teal.500",
                                                    width: {
                                                        base: 4,
                                                        lg: 5
                                                    },
                                                    h: {
                                                        base: 4,
                                                        lg: 5
                                                    },
                                                    borderRadius: "2px",
                                                    marginTop: "3px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    padding: {
                                                        base: 1,
                                                        lg: "6px"
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* CheckIcon */.nQ, {
                                                        color: "white",
                                                        marginTop: "2px",
                                                        width: 2
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                                    fontSize: {
                                                        base: "md",
                                                        lg: "xl"
                                                    },
                                                    lineHeight: {
                                                        base: 6,
                                                        lg: 7
                                                    },
                                                    color: "gray.700",
                                                    textAlign: "left",
                                                    fontWeight: {
                                                        base: 500,
                                                        lg: 400
                                                    },
                                                    children: benefit
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            }),
                            !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                                spacing: 2,
                                alignItems: "flex-start",
                                width: "full",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                        fontSize: "sm",
                                        lineHeight: 5,
                                        color: "gray.600",
                                        maxWidth: 520,
                                        children: "* Base service fee covers mobile app access, plus common area furnishings and kitchen essentials \u2014 valued at more than $5000!"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                        fontSize: "sm",
                                        lineHeight: 5,
                                        color: "gray.600",
                                        children: "** Resident-caused damages are billed to the resident."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Flex */.kC, {
                        marginTop: {
                            base: 4,
                            lg: 10
                        },
                        justifyContent: {
                            base: "center",
                            lg: "unset"
                        },
                        width: {
                            base: "full",
                            lg: "fit-content"
                        },
                        maxWidth: {
                            base: 300,
                            lg: 380
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Img */.Ei, {
                            src: "".concat(benefitsSection)
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_BenefitsSection = (BenefitsSection);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/table/dist/chakra-ui-table.esm.js
var chakra_ui_table_esm = __webpack_require__(79042);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/Footer/components/PricingTableSection/pricingTableFooter.styles.ts

var PricingTableNormalTd = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_table_esm.Td, {
    baseStyle: function() {
        return {
            fontFamily: "Inter",
            fontWeight: {
                base: 500,
                md: 400
            },
            fontSize: "md",
            lineHeight: "6",
            color: "gray.700",
            textAlign: "center",
            width: {
                base: "115px",
                md: "286px"
            },
            height: {
                base: "12",
                md: "60px"
            },
            padding: 0
        };
    }
});
var PricingTableHighlightTd = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_table_esm.Td, {
    baseStyle: function() {
        return {
            backgroundColor: "rgba(230, 255, 250, 0.3)",
            fontWeight: 600,
            fontSize: "md",
            lineHeight: "6",
            color: "gray.700",
            textAlign: "center",
            width: {
                base: "115px",
                md: "286px"
            },
            height: {
                base: "12",
                md: "60px"
            },
            letterSpacing: "unset"
        };
    }
});
var PricingTableTr = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_table_esm.Tr, {
    baseStyle: function() {
        return {
            height: {
                base: "12",
                md: "60px"
            },
            letterSpacing: "unset"
        };
    }
});
var PricingTableTh = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_table_esm.Th, {
    baseStyle: function() {
        return {
            fontWeight: 600,
            fontSize: {
                base: "md",
                md: "20px"
            },
            lineHeight: {
                base: "6",
                lg: "7"
            },
            textTransform: "capitalize",
            color: "gray.700",
            textAlign: "center",
            width: {
                base: "115px !important",
                md: "286px"
            },
            paddingX: {
                base: "7px",
                md: 0
            },
            height: {
                base: "12",
                md: "60px"
            },
            letterSpacing: "unset"
        };
    }
});

;// CONCATENATED MODULE: ./components/Footer/components/PricingTableSection/components/PricingTable/constants.ts
var STUDIO_CLEANING_FEE = 250;
var STUDIO_WIFI_FEE = 120;
var CL_CLEANING_FEE = 125;
var CL_WIFI_FEE = 60;
var HR_CLEANING_FEE = 75;
var HR_WIFI_FEE = 35;
var CL_MARGIN_RATIO = 1.1;
var STUDIO_MARGIN_RATIO = 1.5;
var HR_DIVISION_RATIO = 6;
var CL_DIVISION_RATIO = 4;

// EXTERNAL MODULE: ./constants/common.ts
var constants_common = __webpack_require__(88501);
;// CONCATENATED MODULE: ./components/Footer/components/PricingTableSection/components/PricingTable/utils.ts



function formatPrice(number) {
    return (0,utils_common/* roundNumberToFixedDigits */.ER)(number, 0).replace(constants_common/* NUMBER_WITH_COMMA_PATTERN */.v8, ",");
}
function getPricingTableData(hrAverageRent, hrServiceFee, hasWifi) {
    var clAverageRentNumberData = hrAverageRent * CL_MARGIN_RATIO;
    var studioAverageRentNumberData = hrAverageRent * STUDIO_MARGIN_RATIO;
    var clAverageRent = formatPrice(hrAverageRent * CL_MARGIN_RATIO);
    var studioAverageRent = formatPrice(hrAverageRent * STUDIO_MARGIN_RATIO);
    var hrTotalCost = hasWifi ? formatPrice(hrAverageRent + hrServiceFee + HR_CLEANING_FEE + HR_WIFI_FEE) : formatPrice(hrAverageRent + hrServiceFee + HR_CLEANING_FEE);
    var clTotalCost = hasWifi ? formatPrice(clAverageRentNumberData + CL_CLEANING_FEE + CL_WIFI_FEE) : formatPrice(clAverageRentNumberData + CL_CLEANING_FEE);
    var studioTotalCost = hasWifi ? formatPrice(studioAverageRentNumberData + STUDIO_CLEANING_FEE + STUDIO_WIFI_FEE) : formatPrice(studioAverageRentNumberData + STUDIO_CLEANING_FEE);
    return {
        clAverageRent: clAverageRent,
        studioAverageRent: studioAverageRent,
        hrTotalCost: hrTotalCost,
        clTotalCost: clTotalCost,
        studioTotalCost: studioTotalCost
    };
}

;// CONCATENATED MODULE: ./components/Footer/components/PricingTableSection/components/PricingTable/components/DesktopPricingTable/constants.ts
var EPricingTableThContent;
(function(EPricingTableThContent) {
    EPricingTableThContent["HOMEROOM"] = "HOMEROOM";
    EPricingTableThContent["CRAIGSLIST_ROOM"] = "Craigslist Room";
    EPricingTableThContent["TRADITIONAL_STUDIO"] = "Traditional Studio";
})(EPricingTableThContent || (EPricingTableThContent = {}));
var EPricingTableNormalTdContent;
(function(EPricingTableNormalTdContent) {
    EPricingTableNormalTdContent["AVERAGE_RENT"] = "Average Rent";
    EPricingTableNormalTdContent["CLEANING"] = "Cleaning & yard care";
    EPricingTableNormalTdContent["WIFI"] = "Wifi";
    EPricingTableNormalTdContent["SMART_TV"] = "Smart TV";
    EPricingTableNormalTdContent["COMMON_AREA_FURNISHING"] = "Common area furnishing";
    EPricingTableNormalTdContent["KITCHEN_ESSENTIALS"] = "Kitchen essentials";
    EPricingTableNormalTdContent["SUPPORT_AND_MAINTENANCE"] = "Support and maintenance**";
    EPricingTableNormalTdContent["SERVICES_FEE"] = "Services fee*";
    EPricingTableNormalTdContent["TOTAL_COST"] = "Total cost";
})(EPricingTableNormalTdContent || (EPricingTableNormalTdContent = {}));

;// CONCATENATED MODULE: ./components/Footer/components/PricingTableSection/components/PricingTable/components/DesktopPricingTable/index.tsx








var DesktopPricingTable = function(props) {
    var ref, ref1;
    var metroWithPricing = props.metroWithPricing;
    var ref2;
    var hrAverageRent = (ref2 = metroWithPricing === null || metroWithPricing === void 0 ? void 0 : (ref = metroWithPricing.metroPricing) === null || ref === void 0 ? void 0 : ref.averageRent) !== null && ref2 !== void 0 ? ref2 : 0;
    var ref3;
    var hrServiceFee = (ref3 = metroWithPricing === null || metroWithPricing === void 0 ? void 0 : (ref1 = metroWithPricing.metroPricing) === null || ref1 === void 0 ? void 0 : ref1.serviceFee) !== null && ref3 !== void 0 ? ref3 : 0;
    var ref4 = (0,useFeatureFlagValue/* default */.Z)(featureFlags/* default.WEBSITE_PRICING_TABLE_WIFI */.Z.WEBSITE_PRICING_TABLE_WIFI), tmp = ref4.isEnabled, hasWifi = tmp === void 0 ? false : tmp;
    var ref5 = getPricingTableData(hrAverageRent, hrServiceFee, hasWifi), clAverageRent = ref5.clAverageRent, studioAverageRent = ref5.studioAverageRent, hrTotalCost = ref5.hrTotalCost, clTotalCost = ref5.clTotalCost, studioTotalCost = ref5.studioTotalCost;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_table_esm/* Table */.iA, {
        variant: "simple",
        size: "sm",
        overflowX: "hidden",
        whiteSpace: "normal",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_table_esm/* Thead */.hr, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableTr, {
                    height: {
                        base: 16,
                        md: "60px"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableTh, {
                            textAlign: "left",
                            display: "table-cell",
                            children: metroWithPricing === null || metroWithPricing === void 0 ? void 0 : metroWithPricing.name
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableTh, {
                            backgroundColor: "teal.500",
                            color: "white",
                            borderRadius: "8px 8px 0px 0px",
                            children: EPricingTableThContent.HOMEROOM
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableTh, {
                            fontWeight: 400,
                            fontSize: {
                                base: "md",
                                md: "lg"
                            },
                            children: EPricingTableThContent.CRAIGSLIST_ROOM
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableTh, {
                            fontWeight: 400,
                            fontSize: {
                                base: "md",
                                md: "lg"
                            },
                            children: EPricingTableThContent.TRADITIONAL_STUDIO
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_table_esm/* Tbody */.p3, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableTr, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                textAlign: "left",
                                fontWeight: 600,
                                display: "table-cell",
                                children: EPricingTableNormalTdContent.AVERAGE_RENT
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableHighlightTd, {
                                children: [
                                    "$",
                                    formatPrice(hrAverageRent)
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableNormalTd, {
                                children: [
                                    "$",
                                    clAverageRent
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableNormalTd, {
                                children: [
                                    "$",
                                    studioAverageRent
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableTr, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                textAlign: "left",
                                display: "table-cell",
                                children: EPricingTableNormalTdContent.CLEANING
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableHighlightTd, {
                                children: [
                                    "$",
                                    HR_CLEANING_FEE
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableNormalTd, {
                                children: [
                                    "$",
                                    CL_CLEANING_FEE
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableNormalTd, {
                                children: [
                                    "$",
                                    STUDIO_CLEANING_FEE
                                ]
                            })
                        ]
                    }),
                    hasWifi && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableTr, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                textAlign: "left",
                                display: "table-cell",
                                children: EPricingTableNormalTdContent.WIFI
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableHighlightTd, {
                                children: [
                                    "$",
                                    HR_WIFI_FEE
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableNormalTd, {
                                children: [
                                    "$",
                                    CL_WIFI_FEE
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableNormalTd, {
                                children: [
                                    "$",
                                    STUDIO_WIFI_FEE
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableTr, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                textAlign: "left",
                                display: "table-cell",
                                children: EPricingTableNormalTdContent.SMART_TV
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableHighlightTd, {
                                children: "Included"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                children: "-"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                children: "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableTr, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                textAlign: "left",
                                display: "table-cell",
                                children: EPricingTableNormalTdContent.COMMON_AREA_FURNISHING
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableHighlightTd, {
                                children: "Included"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                children: "-"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                children: "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableTr, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                textAlign: "left",
                                display: "table-cell",
                                children: EPricingTableNormalTdContent.KITCHEN_ESSENTIALS
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableHighlightTd, {
                                children: "Included"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                children: "-"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                children: "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableTr, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                textAlign: "left",
                                display: "table-cell",
                                children: EPricingTableNormalTdContent.SUPPORT_AND_MAINTENANCE
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableHighlightTd, {
                                children: "Included"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                children: "-"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                children: "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableTr, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                textAlign: "left",
                                display: "table-cell",
                                children: EPricingTableNormalTdContent.SERVICES_FEE
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableHighlightTd, {
                                children: [
                                    "$",
                                    formatPrice(hrServiceFee)
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                children: "-"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                children: "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableTr, {
                        height: {
                            base: "10 !important",
                            md: "60px"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableNormalTd, {
                                textAlign: "left",
                                fontWeight: 600,
                                display: "table-cell",
                                paddingY: {
                                    base: 4,
                                    md: "auto"
                                },
                                children: EPricingTableNormalTdContent.TOTAL_COST
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableHighlightTd, {
                                backgroundColor: "teal.500",
                                color: "white",
                                borderRadius: "0px 0px 8px 8px",
                                height: "inherit",
                                children: [
                                    "$",
                                    hrTotalCost
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableNormalTd, {
                                fontWeight: 600,
                                height: "inherit",
                                children: [
                                    "$",
                                    clTotalCost
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTableNormalTd, {
                                fontWeight: 600,
                                height: "inherit",
                                children: [
                                    "$",
                                    studioTotalCost
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_DesktopPricingTable = (DesktopPricingTable);

;// CONCATENATED MODULE: ./components/Footer/components/PricingTableSection/components/PricingTable/components/ResponsivePricingTable/responsivePricingTable.styles.ts

var PricingTable = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_table_esm/* Table */.iA, {
    baseStyle: function() {
        return {
            tableLayout: "fixed",
            variant: "simple",
            size: "sm",
            overflowX: "hidden",
            whiteSpace: "normal"
        };
    }
});
var PricingTh = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_table_esm.Th, {
    baseStyle: function() {
        return {
            padding: 2,
            fontSize: "xs",
            fontWeight: 600,
            lineHeight: 4,
            textAlign: "center",
            textTransform: "capitalize"
        };
    }
});
var PricingTd = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_table_esm.Td, {
    baseStyle: function() {
        return {
            padding: "12px 0px 12px 8px",
            color: "gray.700",
            fontSize: "xs",
            fontWeight: 500,
            lineHeight: 4,
            textAlign: "left"
        };
    }
});
var PricingBoldTd = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_table_esm.Td, {
    baseStyle: function() {
        return {
            paddingX: 0,
            paddingY: 3,
            color: "gray.700",
            fontSize: "sm",
            fontWeight: 600,
            lineHeight: 5,
            textAlign: "center",
            background: "rgba(230, 255, 250, 0.3)"
        };
    }
});
var PricingNormalTd = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_table_esm.Td, {
    baseStyle: function() {
        return {
            paddingX: 0,
            paddingY: 3,
            color: "gray.700",
            fontSize: "sm",
            fontWeight: 400,
            lineHeight: 5,
            textAlign: "center"
        };
    }
});

;// CONCATENATED MODULE: ./components/Footer/components/PricingTableSection/components/PricingTable/components/ResponsivePricingTable/index.tsx








var ResponsivePricingTable = function(props) {
    var ref, ref1;
    var metroWithPricing = props.metroWithPricing;
    var ref2;
    var hrAverageRent = (ref2 = metroWithPricing === null || metroWithPricing === void 0 ? void 0 : (ref = metroWithPricing.metroPricing) === null || ref === void 0 ? void 0 : ref.averageRent) !== null && ref2 !== void 0 ? ref2 : 0;
    var ref3;
    var hrServiceFee = (ref3 = metroWithPricing === null || metroWithPricing === void 0 ? void 0 : (ref1 = metroWithPricing.metroPricing) === null || ref1 === void 0 ? void 0 : ref1.serviceFee) !== null && ref3 !== void 0 ? ref3 : 0;
    var ref4 = (0,useFeatureFlagValue/* default */.Z)(featureFlags/* default.WEBSITE_PRICING_TABLE_WIFI */.Z.WEBSITE_PRICING_TABLE_WIFI), tmp = ref4.isEnabled, hasWifi = tmp === void 0 ? false : tmp;
    var ref5 = getPricingTableData(hrAverageRent, hrServiceFee, hasWifi), studioAverageRent = ref5.studioAverageRent, hrTotalCost = ref5.hrTotalCost, studioTotalCost = ref5.studioTotalCost;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingTable, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_table_esm/* Thead */.hr, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_table_esm.Tr, {
                    height: 12,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTh, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTh, {
                            backgroundColor: "teal.500",
                            color: "white",
                            borderTopRadius: 6,
                            children: EPricingTableThContent.HOMEROOM
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTh, {
                            color: "gray.700",
                            children: EPricingTableThContent.TRADITIONAL_STUDIO
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_table_esm/* Tbody */.p3, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_table_esm.Tr, {
                        height: 11,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTd, {
                                fontWeight: 600,
                                children: EPricingTableNormalTdContent.AVERAGE_RENT
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingBoldTd, {
                                children: [
                                    "$",
                                    formatPrice(hrAverageRent)
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingNormalTd, {
                                children: [
                                    "$",
                                    studioAverageRent
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_table_esm.Tr, {
                        height: 11,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTd, {
                                children: EPricingTableNormalTdContent.CLEANING.split(" ")[0]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingBoldTd, {
                                children: [
                                    "$",
                                    HR_CLEANING_FEE
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingNormalTd, {
                                children: [
                                    "$",
                                    STUDIO_CLEANING_FEE
                                ]
                            })
                        ]
                    }),
                    hasWifi && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_table_esm.Tr, {
                        height: 11,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTd, {
                                children: EPricingTableNormalTdContent.WIFI
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingBoldTd, {
                                children: [
                                    "$",
                                    HR_WIFI_FEE
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingNormalTd, {
                                children: [
                                    "$",
                                    STUDIO_WIFI_FEE
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_table_esm.Tr, {
                        height: 11,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTd, {
                                children: EPricingTableNormalTdContent.SMART_TV
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingBoldTd, {
                                children: "Included"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingNormalTd, {
                                children: "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_table_esm.Tr, {
                        height: 14,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTd, {
                                children: EPricingTableNormalTdContent.COMMON_AREA_FURNISHING
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingBoldTd, {
                                children: "Included"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingNormalTd, {
                                children: "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_table_esm.Tr, {
                        height: 14,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTd, {
                                paddingX: 2,
                                children: EPricingTableNormalTdContent.KITCHEN_ESSENTIALS
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingBoldTd, {
                                children: "Included"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingNormalTd, {
                                children: "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_table_esm.Tr, {
                        height: 14,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTd, {
                                children: EPricingTableNormalTdContent.SUPPORT_AND_MAINTENANCE
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingBoldTd, {
                                children: "Included"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingNormalTd, {
                                children: "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_table_esm.Tr, {
                        height: 11,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTd, {
                                children: EPricingTableNormalTdContent.SERVICES_FEE
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingBoldTd, {
                                children: [
                                    "$",
                                    formatPrice(hrServiceFee)
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingNormalTd, {
                                children: "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_table_esm.Tr, {
                        height: 11,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTd, {
                                fontWeight: 700,
                                children: EPricingTableNormalTdContent.TOTAL_COST
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingBoldTd, {
                                background: "teal.500",
                                color: "white",
                                borderBottomRadius: 6,
                                padding: 2,
                                children: [
                                    "$",
                                    hrTotalCost
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingNormalTd, {
                                children: [
                                    "$",
                                    studioTotalCost
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ResponsivePricingTable = (ResponsivePricingTable);

;// CONCATENATED MODULE: ./components/Footer/components/PricingTableSection/components/PricingTable/index.tsx








var PricingTable_PricingTable = function(props) {
    var metroWithPricing = props.metroWithPricing;
    // *INFO: using for detect with real device
    var isMobileTabletDevice = lib/* isMobile */.tq || lib/* isTablet */.Em;
    var isMobileBreakPoint = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.MD */.yE.MD);
    var ref = (0,react.useState)(false), isResponsive = ref[0], setIsResponsive = ref[1];
    var ref1 = (0,react.useState)(false), isMounted = ref1[0], setIsMounted = ref1[1];
    // *INFO: using check mounted state of component to fix error overwrite style Chakra
    (0,react.useEffect)(function() {
        if (!isMounted) {
            setIsMounted(true);
        }
    }, []);
    // *INFO: using responsive state when change screen size
    (0,react.useEffect)(function() {
        setIsResponsive(isMobileTabletDevice || isMobileBreakPoint);
    }, [
        isMobileBreakPoint
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_table_esm/* TableContainer */.xJ, {
        marginTop: {
            base: "24px !important",
            md: "52px !important"
        },
        width: {
            base: "full",
            lg: "unset"
        },
        children: isResponsive && isMounted ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ResponsivePricingTable, {
            metroWithPricing: metroWithPricing
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DesktopPricingTable, {
            metroWithPricing: metroWithPricing
        })
    });
};
/* harmony default export */ var components_PricingTable = (PricingTable_PricingTable);

;// CONCATENATED MODULE: ./components/Footer/components/PricingTableSection/index.tsx





var PricingTableSection = function(props) {
    var ref, ref1, ref2;
    var _metroWithPricing = props.metroWithPricing, metroWithPricing = _metroWithPricing === void 0 ? {} : _metroWithPricing, _pricingSettings = props.pricingSettings, pricingSettings = _pricingSettings === void 0 ? {} : _pricingSettings;
    var notes = pricingSettings === null || pricingSettings === void 0 ? void 0 : (ref = pricingSettings.note) === null || ref === void 0 ? void 0 : ref.split("<br>");
    //*INFO: replace <cite> to <span> with style follow design
    var title = (ref2 = pricingSettings === null || pricingSettings === void 0 ? void 0 : (ref1 = pricingSettings.title) === null || ref1 === void 0 ? void 0 : ref1.replace(/<cite>(.*?)<\/cite>/g, '<span style="color: teal;">$1</span>')) === null || ref2 === void 0 ? void 0 : ref2.replace(/<\/?cite>/g, "");
    var ref3;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        background: "white",
        paddingX: {
            base: 4,
            md: 8
        },
        paddingY: {
            base: 10,
            md: 20
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
            width: "full",
            spacing: {
                base: 6,
                md: 14,
                lg: 20
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                    spacing: {
                        base: 4,
                        lg: 6
                    },
                    paddingX: {
                        md: "62px"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            fontSize: {
                                base: "xl",
                                md: "3xl",
                                lg: "4xl"
                            },
                            fontWeight: "bold",
                            lineHeight: {
                                base: 7,
                                md: "44px"
                            },
                            align: "center",
                            maxWidth: {
                                base: "85%",
                                md: "100%"
                            },
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            as: "p",
                            fontSize: {
                                base: "md",
                                lg: "lg"
                            },
                            color: "gray.800",
                            align: "center",
                            lineHeight: {
                                base: 6,
                                md: 7
                            },
                            marginTop: {
                                base: 4,
                                md: 6
                            },
                            width: "full",
                            maxWidth: {
                                base: "85%",
                                md: "568px"
                            },
                            dangerouslySetInnerHTML: {
                                __html: (ref3 = pricingSettings === null || pricingSettings === void 0 ? void 0 : pricingSettings.description) !== null && ref3 !== void 0 ? ref3 : ""
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PricingTable, {
                    metroWithPricing: metroWithPricing
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Center */.M5, {
                    marginTop: {
                        base: 6,
                        md: "40px !important"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                        spacing: 2,
                        maxWidth: "506px",
                        children: (0,utils_common/* getValidArray */._b)(notes).map(function(note, index) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                textAlign: "center",
                                fontSize: "sm",
                                color: "gray.600",
                                lineHeight: 5,
                                dangerouslySetInnerHTML: {
                                    __html: note
                                }
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_PricingTableSection = (PricingTableSection);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./components/Footer/components/RenterFAQsSection/NewRenterFAQs/constant.ts
var renterFAQs = [
    {
        title: "Application Process & Requirements",
        questions: [
            {
                question: "What do you require to become a HomeRoom member?",
                answer: "There are six main steps in the application process which include: ",
                ideas: [
                    "Step 1: View our homes: Discover your perfect room here.",
                    "Step 2: Apply: We will conduct comprehensive background and credit checks.",
                    "Step 3: Request a tour: We'll coordinate a roommate call, allowing you to arrange a tour and ensure compatibility.",
                    "Step 4: Explore the space: Tour the house and meet your potential roommates.",
                    "Step 5: Make it official: Digitally review and sign your agreement.",
                    "Step 6: Welcome Home: Obtain your digital access key for the residence and the community."
                ],
                haveLink: true
            },
            {
                question: "What do you look for in applicants?",
                answer: "We are committed to welcoming inclusive residents from all backgrounds who are excited to live with one another and build a household and a community together. You\u2019ll need to meet the following requirements to lease with HomeRoom:",
                ideas: [
                    "Income: Applicants must demonstrate a gross monthly income equal to or exceeding two times the monthly rent.",
                    "Credit Score: Applicants are required to have a positive credit history, characterized by consistent payments and satisfactory debt-to-income ratios.",
                    "Leasing History: Applicants should have no recent evictions on their leasing history.",
                    "Background Report: All applicants must meet our community's standards in accordance with Fair Housing Guidelines and local regulations."
                ]
            },
            {
                question: "What does the application process consist of?",
                answer: "You can complete the entire application process online. To apply, please visit app.livehomeroom.com/apply and submit the following information:",
                ideas: [
                    "Your name and address",
                    "A government-issued form of identification",
                    "Social security number",
                    "Self-reported monthly income",
                    "Verification of your income (e.g., pay stub)",
                    "Application fee of $35"
                ]
            },
            {
                question: "What if I need a cosigner? Who qualifies as a cosigner?",
                answer: "Cosigners must have a U.S. based address and a credit score of 650 or higher as well as  income that is three times the monthly rent."
            },
            {
                question: "What credit score do I need to qualify?",
                answer: "Credit score requirements vary by state."
            }
        ]
    },
    {
        title: "Roommates / Meet & Greet",
        questions: [
            {
                question: "Do I get to meet my roommates?",
                answer: "After your rental application has been approved, we will coordinate a roommate call with current residents of a home you are interested in. From there, you can coordinate a time to meet, set up time to video chat or ask them to take you on a video tour of the home. If, for whatever reason, it's not a mutual fit, HomeRoom will welcome you to chat with other roommates until you find your perfect home."
            },
            {
                question: "What are the house rules for each HomeRoom?",
                answer: "Yes, each house sets its own rules. However, to keep our homes happy we have outlined our Homes Policies here.",
                haveLink: true
            },
            {
                question: "Will I have privacy in the home?",
                answer: "While residents share the entire home, each resident has their own private bedroom within the home."
            },
            {
                question: "How do we choose our roommates?",
                answer: "At HomeRoom, we place community at the core of our mission, and we firmly believe that strong communities begin within the home itself. This is why we meticulously crafted our roommate Meet & Greet process to empower our residents to thoroughly assess, engage in conversations, and acquaint themselves with potential roommates before making the decision to welcome them into their living space."
            },
            {
                question: "Can my spouse  live with me?",
                answer: "All rooms are single occupancy only. For visits, please review our visitor\u2019s Policy here: Community Policies, Rules & Terms.",
                haveLink: true
            },
            {
                question: "What are my responsibilities as a roommate? ",
                answer: "You have a few responsibilities as a roommate and a few little maintenance tasks.",
                ideas: [
                    "Weekly responsibilities like doing your dishes and cleaning after yourself, communicating with your roommates when bringing a visitor, and abiding by your house rules.",
                    "Attending a roommate meeting at least every 3 months and everyday maintenance tasks.",
                    "Examples of other maintenance requests that fall under resident responsibility include:",
                    "Replacing reachable light bulbs",
                    "Replace smart lock and fire alarm batteries",
                    "Plumbing issues like clogged drains that arise due to resident use",
                    "Testing and troubleshooting blown fuses",
                    "Bathroom fixtures like disposable bathroom items, etc.",
                    "AC Filter changing",
                    "Internet troubleshooting",
                    "Small pest issues",
                    "Purchase household items and batteries (detergent, soap, and cleaning tools will be roommates\u2019 responsibility)"
                ]
            }
        ]
    },
    {
        title: "Leasing",
        questions: [
            {
                question: "Are pets allowed?",
                answer: "We don\u2019t allow pets in our homes. Should you require approval for an ESA, send all documentation via email (membersupport@livehomeroom)."
            },
            {
                question: "How long am I able to rent for?",
                answer: "Residents can choose lease terms between 3 and 24 months. Residents can also move freely to other homes in different cities without breaking their lease."
            },
            {
                question: "Do I get to tour the house?",
                answer: "We offer virtual tours along with personalized insights on the home and neighborhood for all of our properties. We also offer in-person tours at select properties."
            },
            {
                question: "Are residents informed when a new roommate signs a lease in their home?",
                answer: "Yes! We\u2019ll send out an email to everyone prior to move in."
            },
            {
                question: "Is smoking allowed in the home?",
                answer: "Smoking and illegal drugs of any kind are not allowed in the home or near the premises."
            },
            {
                question: "Is renter\u2019s insurance required?",
                answer: "Renter\u2019s insurance is a must. Failure to upload your policy number will result in a $50 monthly fee."
            },
            {
                question: "What is the price of the home?",
                answer: "The price of the home or your portion of the rent will be listed on the property listings page at our 12-month lease rate. We offer lease lengths as little as 3 months and as long as 24 months. Pricing can be subject to change based on the lease term."
            }
        ]
    },
    {
        title: "Payments",
        questions: [
            {
                question: "Do you require a security deposit?",
                answer: "When you sign your new lease, depending on the market, we collect a security deposit equal to one month's rent or an approved security deposit alternative. We also collect the first month\u2019s rent and service fees."
            },
            {
                question: "How soon after I move out will I receive my security deposit?",
                answer: "Security deposits will be returned in accordance with applicable law."
            },
            {
                question: "When is my payment due?",
                answer: "Payment is due on the first of every month."
            },
            {
                question: "How can I access my Resident Portal account",
                answer: "Your Resident Portal is available through the pay section in the HomeRoom app. (Pay section)",
                haveLink: true
            }
        ]
    },
    {
        title: "Utilities & Fees",
        questions: [
            {
                question: "What are the move-in costs?",
                answer: "When signing your new lease, you will be required to provide a security deposit equivalent to one month's rent or an approved alternative security deposit. In addition, the initial payment will include the first month's rent, along with service charges such as a utilities pre-payment of $140, a membership fee of $50, and a move-in fee of $300."
            },
            {
                question: "Does HomeRoom offer parking and is there a fee?",
                answer: "Parking is available for many of our homes. This is based on an individual property basis so please check the listing. An additional parking fee also varies by property depending on space limitations."
            },
            {
                question: "What does HomeRoom provide as a service?",
                answer: "We\u2019re committed to providing residents in the HomeRoom community with an outstanding living experience. We charge a monthly membership fee of $50* which includes the below: ",
                ideas: [
                    "Furnished common areas",
                    "Smart TVs",
                    "Kitchen essentials",
                    "Roommate matching",
                    "Internet",
                    "Mobile App Access",
                    "Security Deposit alternatives & help building credit"
                ],
                secondAnswer: "This does not include cleaning fee or utilities. Utilities based on actual usage, split evenly between all roommates."
            },
            {
                question: "Are utilities included in the advertised price?",
                answer: "No, but we make paying for utilities easy for each resident as part of our commitment to streamlining your rental experience. Utilities are based on actual usage and split between roommates."
            }
        ]
    }
];

;// CONCATENATED MODULE: ./components/Footer/components/RenterFAQsSection/NewRenterFAQs/components/RenterFAQItem/components/index.tsx







var RenterFAQAnswer = function(props) {
    var handleOnclick = function handleOnclick() {
        setIsOpen(!isOpen);
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var data = props.data;
    var question = data.question, answer = data.answer, ideas = data.ideas, secondAnswer = data.secondAnswer, haveLink = data.haveLink;
    var ref6 = (0,react.useState)(false), isOpen = ref6[0], setIsOpen = ref6[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        spacing: "0",
        width: "stretch",
        alignItems: "stretch",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                minHeight: "40px",
                height: "fit-content",
                iconSpacing: "auto",
                rightIcon: isOpen ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* MinusIcon */.V_, {
                    position: "absolute",
                    right: 0,
                    bottom: 4,
                    width: "10px",
                    height: "10px"
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* AddIcon */.dt, {
                    position: "absolute",
                    right: 0,
                    bottom: 4,
                    width: "10px",
                    height: "10px"
                }),
                onClick: handleOnclick,
                colorScheme: "teal",
                variant: " solid",
                color: "gray.700",
                paddingX: 4,
                lineHeight: 6,
                _focus: {
                    border: "none"
                },
                transition: "all 250ms",
                textAlign: "left",
                whiteSpace: "pre-line",
                children: question
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_transition_esm/* Collapse */.UO, {
                in: isOpen,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                    alignItems: "flex-start",
                    background: "gray.50",
                    paddingX: 4,
                    width: "stretch",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                        lineHeight: 6,
                        fontWeight: "500",
                        fontSize: "16px",
                        color: "gray.700",
                        children: [
                            haveLink && question === ((ref1 = (ref = renterFAQs[1]) === null || ref === void 0 ? void 0 : ref.questions[1]) === null || ref1 === void 0 ? void 0 : ref1.question) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    "Yes, each house sets its own rules. However, to keep our homes happy,",
                                    " ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                                        _hover: {
                                            color: "teal.700"
                                        },
                                        color: "teal.500",
                                        href: "https://livehomeroom.com/community-policies-rules-terms",
                                        isExternal: true,
                                        children: "we have outlined our Homes Policies here."
                                    })
                                ]
                            }),
                            haveLink && question === ((ref3 = (ref2 = renterFAQs[1]) === null || ref2 === void 0 ? void 0 : ref2.questions[4]) === null || ref3 === void 0 ? void 0 : ref3.question) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    "All rooms are single occupancy only. For visits, please review our visitor\u2019s Policy here:",
                                    " ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                                        _hover: {
                                            color: "teal.700"
                                        },
                                        color: "teal.500",
                                        href: "https://livehomeroom.com/community-policies-rules-terms",
                                        isExternal: true,
                                        children: "Community Policies, Rules & Terms."
                                    })
                                ]
                            }),
                            haveLink && question === ((ref5 = (ref4 = renterFAQs[3]) === null || ref4 === void 0 ? void 0 : ref4.questions[3]) === null || ref5 === void 0 ? void 0 : ref5.question) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    "Your",
                                    " ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                                        _hover: {
                                            color: "teal.700"
                                        },
                                        color: "teal.500",
                                        href: "https://livehomeroom.com/community-policies-rules-terms",
                                        isExternal: true,
                                        children: "Resident Portal"
                                    }),
                                    " ",
                                    "is available through the pay section in the HomeRoom app. (Pay section)"
                                ]
                            }),
                            !haveLink && answer,
                            !isEmpty_default()(ideas) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                                paddingX: 3,
                                paddingY: 3,
                                alignItems: "flex-start",
                                color: "gray.700",
                                spacing: 3,
                                children: (0,utils_common/* getValidArray */._b)(ideas).map(function(idea, index) {
                                    var ref, ref1;
                                    if (question === ((ref1 = (ref = renterFAQs[0]) === null || ref === void 0 ? void 0 : ref.questions[0]) === null || ref1 === void 0 ? void 0 : ref1.question) && index === 0) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                            as: "li",
                                            children: [
                                                "Step 1: View our homes: Discover your perfect room",
                                                " ",
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                                                    _hover: {
                                                        color: "teal.700"
                                                    },
                                                    color: "teal.500",
                                                    href: "https://app.livehomeroom.com/",
                                                    isExternal: true,
                                                    children: "here"
                                                }),
                                                " "
                                            ]
                                        }, index);
                                    }
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                        as: "li",
                                        children: idea
                                    }, index);
                                })
                            }),
                            secondAnswer
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components = (RenterFAQAnswer);

;// CONCATENATED MODULE: ./components/Footer/components/RenterFAQsSection/NewRenterFAQs/components/RenterFAQItem/index.tsx






var RenterFAQItem = function(props) {
    var handleOnclick = function handleOnclick() {
        setIsOpen(!isOpen);
    };
    var data = props.data;
    var title = data.title, questions = data.questions;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        spacing: "0",
        width: "stretch",
        alignItems: "stretch",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                minHeight: "56px",
                height: "fit-content",
                iconSpacing: "auto",
                rightIcon: isOpen ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* MinusIcon */.V_, {
                    width: "10px",
                    height: "10px"
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* AddIcon */.dt, {
                    width: "10px",
                    height: "10px"
                }),
                onClick: handleOnclick,
                colorScheme: "teal",
                variant: " solid",
                background: isOpen ? "teal.500" : "white",
                borderRadius: isOpen ? "6px 6px 0 0" : "6px",
                color: isOpen ? "gray.50" : "gray.700",
                paddingY: 4,
                paddingX: 6,
                fontSize: 18,
                lineHeight: 6,
                transition: "all 250ms",
                _hover: {
                    bg: "teal.600",
                    color: "white",
                    transition: "all 250ms"
                },
                _focus: {
                    boxShadow: "unset"
                },
                textAlign: "left",
                whiteSpace: "pre-line",
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_transition_esm/* Collapse */.UO, {
                in: isOpen,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                    border: "solid 1px",
                    borderColor: "teal.500",
                    background: "gray.50",
                    borderRadius: "0px 0px 6px 6px",
                    padding: "23px",
                    width: "stretch",
                    children: (0,utils_common/* getValidArray */._b)(questions).map(function(question) {
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components, {
                            data: question
                        }, question === null || question === void 0 ? void 0 : question.question);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_RenterFAQItem = (RenterFAQItem);

;// CONCATENATED MODULE: ./components/Footer/components/RenterFAQsSection/NewRenterFAQs/index.tsx







var RenterFAQs = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        width: "full",
        maxWidth: {
            base: "full",
            md: "768px",
            lg: "800px"
        },
        paddingX: {
            base: 4,
            md: "93px",
            lg: "90"
        },
        paddingTop: 4,
        backgroundColor: "orange.50",
        marginX: "auto",
        alignItems: "flex-start",
        minHeight: {
            base: 639,
            md: 607,
            lg: "auto"
        },
        height: "fit-content",
        zIndex: "10",
        marginBottom: {
            lg: 20
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                marginTop: {
                    base: 6,
                    lg: 16
                },
                lineHeight: {
                    base: 7,
                    md: 9,
                    lg: 10
                },
                fontSize: {
                    base: "lg",
                    md: "3xl",
                    lg: "4xl"
                },
                fontWeight: "700",
                color: "gray.800",
                alignSelf: {
                    base: "center",
                    lg: "flex-start"
                },
                marginBottom: {
                    base: 4,
                    lg: 8
                },
                children: "Renter FAQs"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                spacing: 4,
                width: "stretch",
                children: (0,utils_common/* getValidArray */._b)(renterFAQs).map(function(data) {
                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_RenterFAQItem, {
                        data: data
                    }, data === null || data === void 0 ? void 0 : data.title);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                marginTop: {
                    base: "40px !important",
                    md: "0px !important"
                },
                width: "full",
                height: {
                    base: "235px",
                    lg: 0
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Image */.Ee, {
                    marginX: "auto",
                    left: {
                        base: "50%",
                        lg: "75%"
                    },
                    transform: {
                        base: "translate(-50%)",
                        md: "translate(-50%)",
                        lg: "auto"
                    },
                    width: {
                        base: "310px",
                        lg: "333px"
                    },
                    height: "235px",
                    position: {
                        base: "absolute",
                        lg: "absolute"
                    },
                    src: "/assets/images/undraw_questions.svg",
                    alt: "questions",
                    bottom: 0
                })
            })
        ]
    });
};
/* harmony default export */ var NewRenterFAQs = (RenterFAQs);

;// CONCATENATED MODULE: ./components/Footer/components/RenterFAQsSection/index.tsx




var RenterFAQsSection = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        id: "faq",
        background: "orange.50",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
            position: "relative",
            width: "full",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewRenterFAQs, {})
        })
    });
};
/* harmony default export */ var components_RenterFAQsSection = (RenterFAQsSection);

;// CONCATENATED MODULE: ./components/Footer/components/TrustCredibilityFAQsSection/components/TrustCredibilityFAQCard/index.tsx



var TrustCredibilityFAQsCard = function(props) {
    var title = props.title, description = props.description, image = props.image;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        padding: {
            base: 4,
            md: 0,
            lg: 6
        },
        _hover: {
            background: "rgba(255, 255, 255, 0.4)",
            transition: "all 0.3s"
        },
        borderRadius: "8px",
        spacing: {
            base: 2,
            lg: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Image */.Ee, {
                src: image,
                alt: "FAQ",
                marginBottom: 8,
                width: 270,
                height: 236.25
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                width: "full",
                fontSize: {
                    base: "md",
                    lg: "xl"
                },
                fontWeight: "normal",
                align: "center",
                color: "gray.800",
                lineHeight: {
                    base: 6,
                    lg: 7
                },
                marginTop: "0 !important",
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                fontSize: {
                    base: "sm",
                    lg: "md"
                },
                lineHeight: {
                    base: 5,
                    lg: 6
                },
                textAlign: "center",
                color: "gray.800",
                maxWidth: "lg",
                children: description
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Footer/components/TrustCredibilityFAQsSection/constants.tsx


var trustCredibilityFAQsItems = [
    {
        title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                    children: "AMENITIES"
                }),
                "\xa0YOU\u2019LL ACTUALLY LOVE"
            ]
        }),
        description: "Tech-friendly and stylish homes, furnished common areas, really fast WiFi, great community events, 24/7 support, maid and garden service.",
        image: "/assets/images/amenities.png"
    },
    {
        title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
            children: [
                "SERIOUSLY\xa0",
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                    children: "AFFORDABLE"
                }),
                "\xa0RENT"
            ]
        }),
        description: "Low rent to help you chip away at debt and build your savings faster. Flexible leases for life's unexpected changes.",
        image: "/assets/images/affordable_rent.png"
    },
    {
        title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
            children: [
                "NO MORE HIT-OR-MISS\xa0",
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                    children: "ROOMMATES"
                })
            ]
        }),
        description: "Fine-tuned roommate matching to ensure your living preferences and vibe are a fit, HomeRoom sponsored social events to connect with other like-minded members nearby.",
        image: "/assets/images/roommates.png"
    },
    {
        title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
            children: [
                "AN\xa0",
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                    children: "APP"
                }),
                "\xa0FOR EVERYTHING"
            ]
        }),
        description: "Pay rent, lock your bedroom door, RSVP to events, make service requests and so much more all through our renter app.",
        image: "/assets/images/homeroom_app.png"
    }
];

;// CONCATENATED MODULE: ./components/Footer/components/TrustCredibilityFAQsSection/index.tsx







var TrustCredibilityFAQsSection = function() {
    var isNotMobile = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.MD */.yE.MD);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        background: "#f3eada",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
            width: "full",
            paddingX: {
                base: 4,
                md: "93px",
                lg: "150px"
            },
            paddingY: {
                base: 10,
                lg: 20
            },
            spacing: {
                base: 6,
                md: 14,
                lg: 20
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                    spacing: {
                        base: 4,
                        lg: 6
                    },
                    paddingX: {
                        md: "62px"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                            fontSize: {
                                base: "xl",
                                md: "3xl",
                                lg: "4xl"
                            },
                            fontWeight: "bold",
                            lineHeight: {
                                base: 7,
                                md: 10
                            },
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                    as: "span",
                                    color: "teal.500",
                                    children: "More than"
                                }),
                                "\xa0just a house full of random roommates"
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                            fontSize: {
                                base: "md",
                                lg: "lg"
                            },
                            color: "gray.800",
                            align: "center",
                            lineHeight: {
                                base: 6,
                                lg: 7
                            },
                            marginX: {
                                lg: "37.5px !important"
                            },
                            width: "full",
                            maxWidth: {
                                base: "85%",
                                md: "90%",
                                lg: "100%"
                            },
                            children: [
                                "We have elevated the home-sharing concept to a new level.\xa0",
                                isNotMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                "Sure, we match roommates to their ideal houses and roommates,\xa0",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                    as: "span",
                                    fontWeight: "bold",
                                    children: "but there's so much more."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Grid */.rj, {
                    templateColumns: {
                        md: "repeat(2, 1fr)",
                        lg: "repeat(2, 1fr)"
                    },
                    columnGap: 8,
                    rowGap: 10,
                    children: trustCredibilityFAQsItems.map(function(item, index) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustCredibilityFAQsCard, {
                            title: item.title,
                            description: item.description,
                            image: item.image
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_TrustCredibilityFAQsSection = (TrustCredibilityFAQsSection);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var index_esm = __webpack_require__(53854);
;// CONCATENATED MODULE: ./public/assets/icons/hamburger_menu.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 18,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 14h18v-2H0v2ZM0 0v2h18V0H0Zm0 8h18V6H0v2Z",
    fill: "#fff"
  })));
};

/* harmony default export */ var hamburger_menu = (SvgHamburgerMenu);
;// CONCATENATED MODULE: ./components/Header/components/MobileHamburgerMenu/mobileHamburgerMenu.styles.ts

var MobileWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Box */.xu, {
    baseStyle: function() {
        return {
            display: {
                lg: "none"
            },
            ms: "-4"
        };
    }
});
var MobileContainer = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Box */.xu, {
    baseStyle: function() {
        return {
            padding: "0",
            fontSize: "xl",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "48px",
            height: "48px",
            position: "absolute",
            right: 0,
            top: "50%",
            transform: "translateY(-50%)"
        };
    }
});

;// CONCATENATED MODULE: ./components/Header/components/MobileHamburgerMenu/index.tsx





var MobileHamburgerMenu = function(props) {
    var onClick = props.onClick, isOpen = props.isOpen;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileWrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileContainer, {
            as: "button",
            onClick: onClick,
            children: [
                isOpen ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* HiX */.apv, {
                    color: "#fff"
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(hamburger_menu, {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                    srOnly: true,
                    children: isOpen ? "Close menu" : "Open menu"
                })
            ]
        })
    });
};
/* harmony default export */ var components_MobileHamburgerMenu = (MobileHamburgerMenu);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/chakra-ui-menu.esm.js + 3 modules
var chakra_ui_menu_esm = __webpack_require__(42349);
;// CONCATENATED MODULE: ./components/Header/components/Navbar/constants.ts

var whyHomeroomItems = [
    {
        text: "How It Works",
        link: "https://livehomeroom.com/our-tenant-process"
    },
    {
        text: "Features",
        link: "#faq",
        internal: true
    }
];
var resourcesItems = [
    {
        text: "Renter FAQ",
        link: "https://livehomeroom.com/faq"
    },
    {
        text: "Renter application",
        link: "https://homeroom.managebuilding.com/Resident/rental-application/new"
    },
    {
        text: "Contact",
        link: "https://livehomeroom.com/contact-us"
    }
];
var profileActionItems = [
    //* TODO: Update links later
    {
        text: "My Profile",
        link: routes/* default.myProfile.value */.Z.myProfile.value
    }
];
var backgroundItemHeaderHover = "rgba(255, 255, 255, 0.1)";

;// CONCATENATED MODULE: ./components/Header/components/Navbar/components/NavbarDesktop/navbarDesktop.styles.ts


var navbarDesktop_styles_Container = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* HStack */.Ug, {
    baseStyle: function() {
        return {
            spacing: "3",
            flex: "1",
            display: {
                base: "none",
                lg: "flex"
            },
            justifyContent: "flex-end",
            gap: "6"
        };
    }
});
var Link = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Link */.rU, {
    baseStyle: function() {
        return {
            marginInlineStart: "0px !important"
        };
    }
});
var navbarDesktop_styles_Text = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Text */.xv, function() {
    return {
        fontSize: "sm",
        color: "white",
        fontWeight: 600,
        marginRight: "8",
        marginInlineEnd: "32px !important",
        cursor: "pointer"
    };
});
var navbarDesktop_styles_Button = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_button_esm/* Button */.zx, function() {
    return {
        backgroundColor: "teal.200",
        color: "black",
        ":hover": {
            backgroundColor: "teal.300"
        },
        ":active": {
            backgroundColor: "teal.400"
        }
    };
});
var navbarDesktop_styles_DropdownButton = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_button_esm/* Button */.zx, {
    baseStyle: function() {
        return {
            fontSize: "sm",
            color: "teal.50",
            backgroundColor: "transparent",
            fontWeight: 600,
            marginInlineStart: "0px !important",
            cursor: "pointer",
            ":hover": {
                backgroundColor: "transparent",
                color: "teal.100"
            },
            ":active": {
                backgroundColor: "transparent",
                color: "teal.100"
            },
            "&[data-active]": {
                backgroundColor: "transparent",
                color: "teal.100"
            }
        };
    }
});

;// CONCATENATED MODULE: ./components/Header/components/Navbar/components/NavbarDesktop/index.tsx








var NavbarDesktop = function(props) {
    var navLinks = props.navLinks;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(navbarDesktop_styles_Container, {
        children: (0,utils_common/* getValidArray */._b)(navLinks).map(function(navLink, index) {
            if (navLink.type === theme/* NavLink.DROPDOWN */.OL.DROPDOWN) {
                var _link;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_menu_esm/* Menu */.v2, {
                    computePositionOnMount: true,
                    strategy: "fixed",
                    children: function(param) {
                        var isOpen = param.isOpen;
                        var ref;
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_menu_esm/* MenuButton */.j2, {
                                    as: navbarDesktop_styles_DropdownButton,
                                    transition: "all 0.3s",
                                    _hover: {
                                        background: "teal.800",
                                        color: "teal.50"
                                    },
                                    _expanded: {
                                        background: "teal.800",
                                        color: "teal.50"
                                    },
                                    _focus: {
                                        boxShadow: "none"
                                    },
                                    rightIcon: isOpen ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* ChevronUpIcon */.g8, {
                                        fontSize: "md",
                                        marginLeft: 1
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* ChevronDownIcon */.v4, {
                                        fontSize: "md",
                                        marginLeft: 1
                                    }),
                                    children: navLink.text
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_menu_esm/* MenuList */.qy, {
                                    background: "background.primary",
                                    border: "none",
                                    color: "teal.50",
                                    minWidth: "150px",
                                    children: (ref = navLink.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_menu_esm/* MenuItem */.sN, {
                                            _focus: {
                                                background: backgroundItemHeaderHover
                                            },
                                            _active: {
                                                background: backgroundItemHeaderHover
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link, {
                                                href: (_link = item.link) !== null && _link !== void 0 ? _link : "",
                                                isExternal: item.internal ? false : true,
                                                flex: 1,
                                                _active: {
                                                    boxShadow: "none"
                                                },
                                                children: item.text
                                            })
                                        }, item.text);
                                    })
                                })
                            ]
                        });
                    }
                }, index);
            }
            if (navLink.type === theme/* NavLink.EMPTY_DROPDOWN */.OL.EMPTY_DROPDOWN) {
                var ref;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link, {
                    href: (ref = navLink === null || navLink === void 0 ? void 0 : navLink.link) !== null && ref !== void 0 ? ref : "",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(navbarDesktop_styles_DropdownButton, {
                        transition: "all 0.3s",
                        _hover: {
                            background: "teal.800",
                            color: "teal.50"
                        },
                        _expanded: {
                            background: "teal.800",
                            color: "teal.50"
                        },
                        _focus: {
                            boxShadow: "none"
                        },
                        children: navLink.text
                    })
                }, "navbar-item".concat(index));
            }
            var ref1;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link, {
                href: (ref1 = navLink === null || navLink === void 0 ? void 0 : navLink.link) !== null && ref1 !== void 0 ? ref1 : "",
                isExternal: true,
                children: navLink.type === theme/* NavLink.LINK */.OL.LINK ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(navbarDesktop_styles_Text, {
                    children: navLink.text
                }) : navLink.type === theme/* NavLink.BUTTON */.OL.BUTTON && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(navbarDesktop_styles_Button, {
                    lineHeight: 5,
                    fontSize: "sm",
                    children: navLink.text
                })
            }, "navbar-item".concat(index));
        })
    });
};
/* harmony default export */ var components_NavbarDesktop = (NavbarDesktop);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chakra-ui-modal.esm.js + 52 modules
var chakra_ui_modal_esm = __webpack_require__(28018);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/chakra-ui-accordion.esm.js + 2 modules
var chakra_ui_accordion_esm = __webpack_require__(55715);
;// CONCATENATED MODULE: ./components/Header/components/Navbar/components/NavbarMobile/navbarMobile.styles.ts


var Flex = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: function() {
        return {
            flexDirection: "column",
            position: "absolute",
            insetX: "0",
            zIndex: 10000,
            width: "full",
            backgroundColor: "#333333",
            padding: 5,
            height: "100%"
        };
    }
});
var navbarMobile_styles_Box = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* VStack */.gC, {
    baseStyle: function() {
        return {
            paddingX: "3",
            top: "64px",
            position: "relative",
            alignItems: "stretch"
        };
    }
});
var navbarMobile_styles_Text = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Text */.xv, function(props) {
    return {
        width: "full",
        fontSize: "md",
        color: "teal.50",
        fontWeight: 600,
        cursor: "pointer",
        marginLeft: !props.isDropdownItem ? "32px !important" : 0,
        marginRight: !props.isDropdownItem ? "32px !important" : 0,
        paddingBottom: !props.isDropdownItem ? "22px !important" : 0,
        marginTop: !props.isDropdownItem ? "18px !important" : 0,
        borderBottom: props.hasBorder ? "1px solid rgba(255, 255, 255, 0.24)" : "none",
        ":hover": {
            color: "teal.100"
        },
        ":active": {
            color: "teal.200"
        }
    };
});
var navbarMobile_styles_Button = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_button_esm/* Button */.zx, {
    baseStyle: function() {
        return {
            height: 12,
            width: "85%",
            marginTop: "36px !important",
            backgroundColor: "teal.200",
            marginX: "auto",
            color: "black",
            "&:hover": {
                backgroundColor: "teal.300"
            }
        };
    }
});
var DrawerCloseButton = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_modal_esm/* DrawerCloseButton */.cC, {
    baseStyle: function() {
        return {
            size: "md",
            zIndex: 10001,
            color: "white",
            width: 12,
            height: 12
        };
    }
});
var navbarMobile_styles_DropdownButton = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_button_esm/* Button */.zx, {
    baseStyle: function() {
        return {
            fontSize: "md",
            color: "white",
            justifyContent: "flex-start",
            padding: 0,
            marginX: "32px !important",
            backgroundColor: "transparent",
            fontWeight: 600,
            cursor: "pointer",
            ":hover": {
                backgroundColor: "transparent",
                color: "teal.100"
            },
            ":active": {
                backgroundColor: "transparent",
                color: "teal.100"
            },
            ":focus": {
                boxShadow: "none"
            },
            "&[data-active]": {
                backgroundColor: "transparent",
                color: "teal.100"
            }
        };
    }
});

;// CONCATENATED MODULE: ./components/Header/components/Navbar/components/NavbarMobile/index.tsx






var NavbarMobile = function(props) {
    var isOpen = props.isOpen, toggle = props.toggle, navLinks = props.navLinks;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* Drawer */.dy, {
        isOpen: isOpen,
        onClose: toggle,
        size: "sm",
        placement: "right",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* DrawerOverlay */.P1, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* DrawerContent */.sc, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DrawerCloseButton, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex, {
                        overflowY: "auto",
                        as: "nav",
                        background: "background.primary",
                        padding: 0,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(navbarMobile_styles_Box, {
                            padding: 0,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_accordion_esm/* Accordion */.UQ, {
                                defaultIndex: 0,
                                allowToggle: true,
                                children: (0,utils_common/* getValidArray */._b)(navLinks).map(function(navLink, index) {
                                    if (navLink.type === theme/* NavLink.DROPDOWN */.OL.DROPDOWN) {
                                        var ref;
                                        var _link;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_accordion_esm/* AccordionItem */.Qd, {
                                                border: "none",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_accordion_esm/* AccordionButton */.KF, {
                                                        height: 16,
                                                        paddingX: 8,
                                                        paddingY: 5,
                                                        justifyContent: "space-between",
                                                        _hover: {
                                                            background: "transparent"
                                                        },
                                                        _expanded: {
                                                            background: "transparent"
                                                        },
                                                        _focus: {
                                                            boxShadow: "none"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                                                fontSize: "md",
                                                                lineHeight: 6,
                                                                fontWeight: "semibold",
                                                                color: "teal.50",
                                                                margin: 0,
                                                                children: navLink.text
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_accordion_esm/* AccordionIcon */.XE, {
                                                                color: "gray.50",
                                                                fontSize: "md"
                                                            })
                                                        ]
                                                    }, index),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_accordion_esm/* AccordionPanel */.Hk, {
                                                        padding: 0,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                                                            background: "rgba(49, 151, 149, 0.15)",
                                                            border: "none",
                                                            spacing: 6,
                                                            alignItems: "flex-start",
                                                            paddingY: 5,
                                                            paddingX: 8,
                                                            children: (ref = navLink.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(navbarMobile_styles_Text, {
                                                                    isDropdownItem: true,
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                                                                        display: "block",
                                                                        href: (_link = item.link) !== null && _link !== void 0 ? _link : "",
                                                                        onClick: function() {
                                                                            return toggle();
                                                                        },
                                                                        isExternal: item.internal ? false : true,
                                                                        _active: {
                                                                            boxShadow: "none"
                                                                        },
                                                                        children: item.text
                                                                    })
                                                                }, item.text);
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }, "dropdown-mobile-item".concat(index));
                                    }
                                    if (navLink.type === theme/* NavLink.EMPTY_DROPDOWN */.OL.EMPTY_DROPDOWN) {
                                        var ref1;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                                            height: 16,
                                            paddingX: 8,
                                            paddingY: 5,
                                            justifyContent: "space-between",
                                            background: "transparent",
                                            width: "100%",
                                            _hover: {
                                                background: "transparent"
                                            },
                                            _expanded: {
                                                background: "transparent"
                                            },
                                            _focus: {
                                                boxShadow: "none"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                                                href: (ref1 = navLink === null || navLink === void 0 ? void 0 : navLink.link) !== null && ref1 !== void 0 ? ref1 : "",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                                    fontSize: "md",
                                                    lineHeight: 6,
                                                    fontWeight: "semibold",
                                                    color: "teal.50",
                                                    margin: 0,
                                                    children: navLink.text
                                                })
                                            }, "navbar-item".concat(index))
                                        }, index);
                                    }
                                    var ref2;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                                        href: (ref2 = navLink === null || navLink === void 0 ? void 0 : navLink.link) !== null && ref2 !== void 0 ? ref2 : "",
                                        isExternal: true,
                                        children: navLink.type === theme/* NavLink.LINK */.OL.LINK ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(navbarMobile_styles_Text, {
                                            hasBorder: index === navLinks.length - 2 ? false : true,
                                            children: navLink.text
                                        }) : navLink.type === theme/* NavLink.BUTTON */.OL.BUTTON && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(navbarMobile_styles_Button, {
                                            alignItems: "center",
                                            marginLeft: 8,
                                            marginY: 6,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                                color: "black",
                                                lineHeight: 7,
                                                fontSize: "18px",
                                                children: navLink.text
                                            })
                                        })
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_NavbarMobile = (NavbarMobile);

;// CONCATENATED MODULE: ./components/Header/components/Navbar/utils.ts



function getMetroItems(metroList) {
    var metroItems = (0,utils_common/* getValidArray */._b)(metroList).map(function(metro) {
        var ref, _name;
        return {
            text: (ref = metro === null || metro === void 0 ? void 0 : metro.name) !== null && ref !== void 0 ? ref : "",
            link: "".concat(routes/* default.home.value */.Z.home.value, "?metro=").concat(encodeURIComponent((_name = metro.name) !== null && _name !== void 0 ? _name : "")),
            internal: true
        };
    });
    return metroItems;
}
function getNavLinks(metroList) {
    var navLinks = [
        {
            type: theme/* NavLink.DROPDOWN */.OL.DROPDOWN,
            text: "Lease A Room",
            items: getMetroItems(metroList)
        },
        {
            type: theme/* NavLink.EMPTY_DROPDOWN */.OL.EMPTY_DROPDOWN,
            text: "List Your Home",
            link: "https://livehomeroom.com/convert-to-roommate-living"
        },
        {
            type: theme/* NavLink.BUTTON */.OL.BUTTON,
            link: "https://livehomeroom.com/invest ",
            text: "Invest in a property"
        }
    ];
    return navLinks;
}

// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/chakra-ui-hooks.esm.js + 1 modules
var chakra_ui_hooks_esm = __webpack_require__(22547);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./theme/globalStyles.ts
var globalStyles = __webpack_require__(86229);
// EXTERNAL MODULE: ./API/constants.ts
var constants = __webpack_require__(98371);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/index.tsx + 13 modules
var LoginModal = __webpack_require__(96002);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/avatar/dist/chakra-ui-avatar.esm.js
var chakra_ui_avatar_esm = __webpack_require__(7657);
;// CONCATENATED MODULE: ./components/Header/components/UserAvatar/index.tsx



var defaultAvatar = "/assets/icons/green-default-avatar.svg";
var UserAvatar = function(props) {
    var avatarUrl = props.avatarUrl, name = props.name;
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_avatar_esm/* Avatar */.qE, {
        name: avatarUrl ? "" : name,
        colorScheme: "teal",
        src: (ref = avatarUrl !== null && avatarUrl !== void 0 ? avatarUrl : name) !== null && ref !== void 0 ? ref : defaultAvatar,
        size: "sm",
        border: avatarUrl || name ? "2px solid ".concat(globalStyles/* backgroundSecondary */.H2) : ""
    });
};
/* harmony default export */ var components_UserAvatar = (UserAvatar);

;// CONCATENATED MODULE: ./components/Header/components/UserProfile/userProfile.styles.ts


var MenuItem = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_menu_esm/* MenuItem */.sN, {
    baseStyle: function() {
        return {
            maxHeight: "32px",
            _focus: {
                background: backgroundItemHeaderHover
            },
            _active: {
                background: backgroundItemHeaderHover
            },
            _hover: {
                background: backgroundItemHeaderHover
            },
            paddingY: "6px",
            paddingX: "12px"
        };
    }
});
var MenuItemText = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Text */.xv, {
    baseStyle: function() {
        return {
            fontSize: "sm",
            fontWeight: "600",
            lineHeight: "20px",
            color: "teal.50",
            width: "100%",
            height: "100%"
        };
    }
});

;// CONCATENATED MODULE: ./components/Header/components/UserProfile/index.tsx



















var UserProfile = function() {
    var handleLogout = function handleLogout() {
        if (router.pathname.includes(routes/* default.myProfile.value */.Z.myProfile.value)) {
            router.push(routes/* default.home.value */.Z.home.value);
        }
        authStore.clearAccessToken(constants/* PLATFORM.WEBSITE */.iw.WEBSITE);
        react_toastify_esm/* toast.success */.Am.success("Logged out successfully.");
    };
    var handleOpenLoginModal = function handleOpenLoginModal() {
        onOpenLoginModal();
    };
    var setAccessToken = function setAccessToken() {
        localStorage.setItem(constants/* ETokenKey.WEBSITE_ACCESS_TOKEN */.XD.WEBSITE_ACCESS_TOKEN, token);
    };
    var ref, ref1;
    var authStore = (0,useStores/* useStores */.m)().authStore;
    var router = (0,next_router.useRouter)();
    var route = router.route;
    var user = authStore.user, isLogin = authStore.isLogin;
    var ref2 = (0,chakra_ui_hooks_esm/* useDisclosure */.qY)(), isOpenLoginModal = ref2.isOpen, onCloseLoginModal = ref2.onClose, onOpenLoginModal = ref2.onOpen;
    var isEmailVerified = ((ref = router.query) === null || ref === void 0 ? void 0 : ref.isEmailVerified) ? true : false;
    var ref3;
    var token = "".concat((ref3 = (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.token) !== null && ref3 !== void 0 ? ref3 : "");
    function handleAuthAfterEmailVerification() {
        return _handleAuthAfterEmailVerification.apply(this, arguments);
    }
    function _handleAuthAfterEmailVerification() {
        _handleAuthAfterEmailVerification = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var errorMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setAccessToken();
                        authStore.setLogin(true);
                        _ctx.next = 5;
                        return authStore.getMyUser(constants/* PLATFORM.WEBSITE */.iw.WEBSITE);
                    case 5:
                        _ctx.next = 12;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        errorMessage = get_default()(_ctx.t0, "response.data.error.message", "") || JSON.stringify(_ctx.t0);
                        (0,API_error/* handleError */.S)(_ctx.t0, "components/Header/components/UserProfile", "handleAuthAfterEmailVerification");
                        throw new Error(errorMessage);
                    case 12:
                        _ctx.prev = 12;
                        if (route.includes("my-profile")) {
                            router.push(routes/* default.myProfile.value */.Z.myProfile.value);
                            react_toastify_esm/* toast.success */.Am.success("Update email successfully!", {
                                toastId: "email-verified"
                            });
                        } else {
                            router.push(routes/* default.home.value */.Z.home.value);
                            react_toastify_esm/* toast.success */.Am.success("Your account is activated successfully!", {
                                toastId: "email-verified"
                            });
                        }
                        authStore.updateUserProfile({
                            isEmailVerified: true
                        }, constants/* PLATFORM.WEBSITE */.iw.WEBSITE);
                        return _ctx.finish(12);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7,
                    12,
                    16
                ]
            ]);
        }));
        return _handleAuthAfterEmailVerification.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        if (isEmailVerified && token) {
            handleAuthAfterEmailVerification();
        }
    }, [
        isEmailVerified,
        token
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_menu_esm/* Menu */.v2, {
        autoSelect: false,
        computePositionOnMount: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_menu_esm/* MenuButton */.j2, {
                transition: "all 0.3s",
                _expanded: {
                    background: "teal.800",
                    color: "teal.50"
                },
                _focus: {
                    boxShadow: "none"
                },
                _active: {
                    background: "none"
                },
                marginLeft: 6,
                position: {
                    base: "absolute",
                    lg: "static"
                },
                //* INFO: depends on the width of hamburger menu and spacing between hamburger menu and user profile
                right: 16,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_UserAvatar, {
                    avatarUrl: user === null || user === void 0 ? void 0 : user.avatarUrl,
                    name: isLogin ? user === null || user === void 0 ? void 0 : user.name : undefined
                })
            }),
            isLogin ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_menu_esm/* MenuList */.qy, {
                minWidth: "150px",
                background: globalStyles/* backgroundPrimary */.Sm,
                borderRadius: "6px",
                borderWidth: 0,
                paddingY: "6px",
                children: [
                    (0,utils_common/* getValidArray */._b)(profileActionItems).map(function(item, index) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                                href: item.link,
                                width: "full",
                                _focus: {
                                    boxShadow: "none"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItemText, {
                                    children: item === null || item === void 0 ? void 0 : item.text
                                })
                            })
                        }, index);
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Divider */.iz, {
                        color: "teal.50"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItemText, {
                            onClick: handleLogout,
                            children: "Log out"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_menu_esm/* MenuList */.qy, {
                minWidth: "150px",
                background: globalStyles/* backgroundPrimary */.Sm,
                borderRadius: "6px",
                borderWidth: 0,
                paddingY: "6px",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItemText, {
                        onClick: handleOpenLoginModal,
                        children: "Log in"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginModal/* default */.Z, {
                isOpen: isOpenLoginModal,
                onOpen: onOpenLoginModal,
                onClose: onCloseLoginModal
            })
        ]
    });
};
/* harmony default export */ var components_UserProfile = ((0,mobxreact_esm/* observer */.Pi)(UserProfile));

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(84632);
;// CONCATENATED MODULE: ./components/Header/header.styles.ts




var header_styles_Container = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Box */.xu, function() {
    return {
        backgroundColor: "background.primary",
        width: "100%",
        paddingX: {
            base: 4,
            md: 8
        },
        zIndex: theme/* EZIndexLayer.NAV */.qd.NAV,
        position: "sticky",
        top: 0,
        height: "64px"
    };
});
var header_styles_Box = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Box */.xu, function() {
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        boxShadow: "none",
        backgroundColor: "transparent"
    };
});
var HeaderWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Box */.xu, {
    baseStyle: function() {
        return {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingY: "3",
            position: "relative"
        };
    }
}), {
    target: "ekvgv1p0"
})("img{cursor:pointer;}");

;// CONCATENATED MODULE: ./components/Header/index.tsx

















var Header = function(props) {
    var toggle = function toggle() {
        setIsMenuOpen(!isMenuOpen);
    };
    var goHomePage = function goHomePage() {
        router.push(routes/* default.home.value */.Z.home.value);
    };
    var getRedirectLink = function getRedirectLink() {
        if ("production" === common/* EnvironmentEnum.STAGING */.mf.STAGING) {
            return redirectLinkToStaging;
        }
        if ("production" === common/* EnvironmentEnum.PRODUCTION */.mf.PRODUCTION) {
            return redirectLinkToProduction;
        }
        return "/";
    };
    var metroList = props.metroList;
    var ref = (0,react.useState)(false), isMenuOpen = ref[0], setIsMenuOpen = ref[1];
    var ref1 = (0,react.useState)(""), redirectLink = ref1[0], setRedirectLink = ref1[1];
    var isDesktop = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.LG */.yE.LG);
    var isMobile = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.MD */.yE.MD);
    var ref2 = (0,useFeatureFlagValue/* default */.Z)(featureFlags/* default.WEBSITE_LOGIN */.Z.WEBSITE_LOGIN), isEnableLoginFeature = ref2.isEnabled;
    var redirectLinkToStaging = "https://staging.livehomeroom.com/";
    var redirectLinkToProduction = "https://livehomeroom.com/";
    (0,react.useEffect)(function() {
        if (isDesktop && isMenuOpen) {
            setIsMenuOpen(false);
        }
    }, [
        isDesktop
    ]);
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var finalRedirectLink = getRedirectLink();
        setRedirectLink(finalRedirectLink);
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(header_styles_Container, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderWrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                    isExternal: true,
                    href: redirectLink,
                    height: isMobile ? "24px" : "33px",
                    marginY: {
                        base: 2,
                        md: 1,
                        lg: 0
                    },
                    _focus: {
                        boxShadow: "none"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                        alt: "logo",
                        width: isMobile ? 162.46 : 223,
                        height: isMobile ? 24 : 33,
                        onClick: goHomePage,
                        iconName: "logo_with_black_color.svg",
                        className: "header-logo"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_MobileHamburgerMenu, {
                    isOpen: isMenuOpen,
                    onClick: toggle
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_NavbarMobile, {
                    navLinks: getNavLinks(metroList),
                    isOpen: isMenuOpen,
                    toggle: toggle
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_NavbarDesktop, {
                    navLinks: getNavLinks(metroList)
                }),
                isEnableLoginFeature && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_UserProfile, {})
            ]
        })
    });
};
/* harmony default export */ var components_Header = (Header);

;// CONCATENATED MODULE: ./components/Layout/MainLayout/index.tsx

















var MainLayout = function(props) {
    var getReferrerAndSetToLocalStorage = function getReferrerAndSetToLocalStorage() {
        var ref;
        if (!document || !window) {
            return;
        }
        var ref1;
        var referrer = (ref1 = document === null || document === void 0 ? void 0 : document.referrer) !== null && ref1 !== void 0 ? ref1 : "";
        var ref2;
        var hostname = (ref2 = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.hostname) !== null && ref2 !== void 0 ? ref2 : "";
        //*INFO: if document referrer is not in the same domain, then store the referrer in sessionStorage
        if (referrer && (referrer === null || referrer === void 0 ? void 0 : referrer.indexOf(hostname)) === -1) {
            localStorage.setItem(common/* LocalStorageKeyEnum.REFERRER */.eh.REFERRER, referrer);
        }
    };
    var title = props.title, children = props.children, _haveFAQs = props.haveFAQs, haveFAQs = _haveFAQs === void 0 ? true : _haveFAQs, isEntireHouse = props.isEntireHouse, _metroList = props.metroList, metroList = _metroList === void 0 ? [] : _metroList, hasPricingTable = props.hasPricingTable, metroWithPricing = props.metroWithPricing, pricingSettings = props.pricingSettings, _haveTrustCredibilitySection = props.haveTrustCredibilitySection, haveTrustCredibilitySection = _haveTrustCredibilitySection === void 0 ? true : _haveTrustCredibilitySection;
    var ref = (0,useStores/* useStores */.m)(), metroStore = ref.metroStore, authStore = ref.authStore;
    var metroListStore = metroStore.metroList;
    var hasMetro = !!(metroWithPricing === null || metroWithPricing === void 0 ? void 0 : metroWithPricing.name);
    var ref1 = (0,useFeatureFlagValue/* default */.Z)(featureFlags/* default.PRICING_TABLE */.Z.PRICING_TABLE), isEnablePricingTable = ref1.isEnabled;
    var isShowPricingTableSection = hasPricingTable && isEnablePricingTable && hasMetro;
    function getCurrentUser() {
        return _getCurrentUser.apply(this, arguments);
    }
    function _getCurrentUser() {
        _getCurrentUser = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return authStore.getWebsiteAccessToken();
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,API_error/* handleError */.S)(_ctx.t0, "components/Layout/MainLayout", "getCurrentUser");
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return _getCurrentUser.apply(this, arguments);
    }
    function fetchMetroList() {
        return _fetchMetroList.apply(this, arguments);
    }
    function _fetchMetroList() {
        _fetchMetroList = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        try {
                            metroStore.fetchMetroList({
                                where: {
                                    isActive: {
                                        neq: false
                                    }
                                }
                            });
                        } catch (error) {
                            (0,API_error/* handleError */.S)(error, "components/Layout/MainLayout", "fetchMetroList");
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _fetchMetroList.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        getCurrentUser();
        getReferrerAndSetToLocalStorage();
        if ((metroList === null || metroList === void 0 ? void 0 : metroList.length) === 0) {
            fetchMetroList();
        } else {
            metroStore.setMetroList(metroList);
        }
    }, []);
    // *TODO: remove the Amplitude service and will replace it with Google Analytics
    // useEffect(() => {
    //   if (isReady && window && AMPLITUDE_API_KEY && window?.localStorage) {
    //     initAmplitude()
    //     const lastViewedPropertyId: string | undefined =
    //       localStorage.getItem(LocalStorageKeyEnum.LAST_VIEWED_PROPERTY_ID) || undefined
    //     const amplitudeInstance: AmplitudeClient = amplitude.getInstance()
    //     const pageUrl: string = window?.location?.href ?? ''
    //     const pageName: string[] = String(title).split(' | ')
    //     if (pageName.length > 1 && pageName[1] === 'House Detail') {
    //       amplitudeInstance.logEvent(ActionEnum.DETAIL_PAGE_LOADED, { pageUrl, lastViewedPropertyId })
    //     }
    //     const pageAction: string = snakeCase((pageName?.length > 1 ? pageName[1] : title) + ' Page Loaded')
    //     amplitudeInstance.logEvent(pageAction, { pageUrl, lastViewedPropertyId })
    //   }
    // }, [isReady, AMPLITUDE_API_KEY, title])
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                        children: title || "HomeRoom"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "icon",
                        href: "/favicon_black.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Header, {
                metroList: metroListStore
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("main", {
                children: children
            }),
            haveFAQs && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    haveTrustCredibilitySection && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_TrustCredibilityFAQsSection, {}),
                    isShowPricingTableSection && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PricingTableSection, {
                                metroWithPricing: metroWithPricing,
                                pricingSettings: pricingSettings
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_BenefitsSection, {
                                metroWithPricing: metroWithPricing
                            })
                        ]
                    }),
                    !isEntireHouse && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_RenterFAQsSection, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Footer.Desktop, {
                metroList: metroListStore
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Footer.Mobile, {
                metroList: metroListStore
            })
        ]
    });
};
/* harmony default export */ var Layout_MainLayout = ((0,mobxreact_esm/* observer */.Pi)(MainLayout));


/***/ }),

/***/ 6538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);


var NextLink = function(props) {
    var href = props.href, children = props.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
        href: href !== null && href !== void 0 ? href : "/",
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("a", {
            target: "_blank",
            rel: "noreferrer",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NextLink);


/***/ }),

/***/ 84922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59876);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3789);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68527);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4612);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85054);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87536);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53854);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2910);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);








var PasswordField = function(props) {
    var onClickShowButton = function onClickShowButton() {
        toggleShow(!isShow);
    };
    var ref;
    var _name = props.name, name = _name === void 0 ? "password" : _name, _label = props.label, label = _label === void 0 ? "Password" : _label, _placeholder = props.placeholder, placeholder = _placeholder === void 0 ? "Enter your password" : _placeholder, pattern = props.pattern, autoFocus = props.autoFocus, _height = props.height, height = _height === void 0 ? "40px" : _height, hasInfoIcon = props.hasInfoIcon, validate = props.validate;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isShow = ref1[0], toggleShow = ref1[1];
    var ref2 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .useFormContext */ .Gc)(), register = ref2.register, errors = ref2.formState.errors;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .FormControl */ .NI, {
        id: name,
        isInvalid: errors[name],
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .HStack */ .Ug, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .FormLabel */ .lX, {
                        marginBottom: 2,
                        marginRight: 2,
                        color: "gray.700",
                        children: label
                    }),
                    hasInfoIcon && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_5__/* .InfoOutlineIcon */ .hQ, {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().infoIcon),
                        color: "teal.500",
                        display: {
                            base: "none",
                            lg: "block"
                        },
                        boxSize: 3
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .InputGroup */ .BZ, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .InputRightElement */ .xH, {
                        height: height,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .IconButton */ .hU, {
                            background: "transparent !important",
                            variant: "ghost",
                            "aria-label": isShow ? "Mask password" : "Reveal password",
                            icon: isShow ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(react_icons_hi__WEBPACK_IMPORTED_MODULE_9__/* .HiEyeOff */ .MBb, {
                                color: "#A0AEC0"
                            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(react_icons_hi__WEBPACK_IMPORTED_MODULE_9__/* .HiEye */ .Rbo, {
                                color: "#A0AEC0"
                            }),
                            onClick: onClickShowButton,
                            height: height
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Input */ .II, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        autoFocus: autoFocus,
                        type: isShow ? "text" : "password",
                        autoComplete: "password",
                        placeholder: placeholder,
                        height: height
                    }, register(name, {
                        required: "".concat(label, " is required"),
                        pattern: pattern,
                        validate: validate
                    })))
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .FormErrorMessage */ .J1, {
                children: errors[name] && ((ref = errors[name]) === null || ref === void 0 ? void 0 : ref.message)
            })
        ]
    });
};
PasswordField.displayName = "PasswordField";
/* harmony default export */ __webpack_exports__["Z"] = (PasswordField);


/***/ }),

/***/ 96002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LoginModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chakra-ui-modal.esm.js + 52 modules
var chakra_ui_modal_esm = __webpack_require__(28018);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js
var chakra_ui_system_esm = __webpack_require__(46052);
// EXTERNAL MODULE: ./enums/theme/index.ts
var theme = __webpack_require__(60431);
// EXTERNAL MODULE: ./hooks/useBreakPoint.ts
var useBreakPoint = __webpack_require__(41894);
// EXTERNAL MODULE: ./hooks/useStores.ts
var useStores = __webpack_require__(19263);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js
var mobxreact_esm = __webpack_require__(29323);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./API/authenticate/index.ts
var authenticate = __webpack_require__(32035);
// EXTERNAL MODULE: ./API/error.ts
var error = __webpack_require__(76214);
// EXTERNAL MODULE: ./components/pages/DetailPage/constants.ts
var constants = __webpack_require__(63516);
// EXTERNAL MODULE: ./constants/common.ts
var common = __webpack_require__(88501);
// EXTERNAL MODULE: ./utils/common.ts
var utils_common = __webpack_require__(6628);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/chakra-ui-image.esm.js + 1 modules
var chakra_ui_image_esm = __webpack_require__(78428);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/CompleteScreen/index.tsx



var CompleteScreen = function(props) {
    var _bodyText = props.bodyText, bodyText = _bodyText === void 0 ? "Your account has been created successfully" : _bodyText;
    var welcomeImageUrl = "/assets/images/welcome.png";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalContent */.hz, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalHeader */.xB, {
                fontSize: "lg",
                color: "gray.800",
                fontWeight: 500,
                lineHeight: 7,
                borderBottom: "1px",
                borderColor: "gray.200",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        children: "Welcome to HomeRoom"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalCloseButton */.ol, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalBody */.fe, {
                lineHeight: 7,
                color: "gray.700",
                fontWeight: 500,
                paddingY: 14,
                paddingX: 12,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Image */.Ee, {
                            src: welcomeImageUrl,
                            alt: "welcome",
                            width: 16,
                            height: 16
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            fontSize: "xl",
                            children: "CONGRATS!"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            textAlign: "center",
                            children: bodyText
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_CompleteScreen = (CompleteScreen);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js + 1 modules
var chakra_ui_button_esm = __webpack_require__(85054);
// EXTERNAL MODULE: ./API/constants.ts
var API_constants = __webpack_require__(98371);
// EXTERNAL MODULE: ./components/FormInput/index.tsx
var FormInput = __webpack_require__(10150);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/constant.ts
var ELoginType;
(function(ELoginType) {
    ELoginType["PHONE_NUMBER"] = "phoneNumber";
    ELoginType["EMAIL"] = "email";
    ELoginType["FACEBOOK"] = "facebook";
    ELoginType["GOOGLE"] = "google";
})(ELoginType || (ELoginType = {}));
var ECurrentStep;
(function(ECurrentStep) {
    ECurrentStep["VERIFICATION"] = "verification";
    ECurrentStep["SIGN_UP"] = "signUp";
    ECurrentStep["PERSONAL_INFORMATION"] = "personalInformation";
    ECurrentStep["FORGOT_PASSWORD"] = "forgotPassword";
    ECurrentStep["RESET_PASSWORD"] = "resetPassword";
    ECurrentStep["COMPLETE"] = "complete";
    ECurrentStep["EMAIL_VERIFICATION"] = "emailVerification";
})(ECurrentStep || (ECurrentStep = {}));

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/ForgotPassword/index.tsx











var ForgotPassword = function(props) {
    var backToLoginWithPhoneNumber = function backToLoginWithPhoneNumber() {
        setCurrentStep(ECurrentStep.PERSONAL_INFORMATION);
        setLoginType(ELoginType.PHONE_NUMBER);
    };
    var setCurrentStep = props.setCurrentStep, setLoginType = props.setLoginType;
    var control = (0,index_esm/* useFormContext */.Gc)().control;
    var ref = (0,react.useState)(false), isSent = ref[0], setIsSent = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var userEmail = (0,index_esm/* useWatch */.qo)({
        control: control,
        name: "email"
    }) || "";
    function onSubmit() {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setIsLoading(true);
                        _ctx.next = 4;
                        return (0,authenticate/* forgotPassword */.gF)({
                            email: userEmail,
                            platform: API_constants/* PLATFORM.WEBSITE */.iw.WEBSITE
                        });
                    case 4:
                        setIsLoading(false);
                        setIsSent(true);
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,error/* handleError */.S)(_ctx.t0, "components/pages/DetailPage/components/SideBar/components/LoginModal/components/ForgotPassword/index.tsx", "onSubmit");
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return _onSubmit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalContent */.hz, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalHeader */.xB, {
                fontSize: "lg",
                color: "gray.800",
                fontWeight: 500,
                lineHeight: 7,
                borderBottom: "1px",
                borderColor: "gray.200",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        children: "Forgot Password?"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalCloseButton */.ol, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalBody */.fe, {
                fontWeight: 500,
                paddingY: 6,
                paddingX: {
                    base: 4,
                    md: 6
                },
                children: isSent ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                    height: "200px",
                    alignItems: "flex-start",
                    spacing: 6,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            children: "Please check your email and follow the instruction to reset your password"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                            children: [
                                "If you don\u2019t receive the email, check your Spam or",
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                    color: "teal.500",
                                    cursor: "pointer",
                                    onClick: function() {
                                        return setIsSent(false);
                                    },
                                    children: "ask again to reset your password"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                    alignItems: "flex-start",
                    spacing: 6,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            children: "Please enter the email address associated with your account, we will send you a link to reset password"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                            name: "email",
                            label: "Your Email Address",
                            placeholder: "Enter Your Email"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            as: "u",
                            color: "blue.500",
                            fontWeight: 400,
                            cursor: "pointer",
                            onClick: backToLoginWithPhoneNumber,
                            children: "Or login with phone number"
                        })
                    ]
                })
            }),
            !isSent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalFooter */.mz, {
                paddingTop: 4,
                paddingBottom: 4,
                borderTop: "1px",
                borderColor: "gray.200",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                        colorScheme: "teal",
                        variant: "link",
                        lineHeight: 6,
                        fontWeight: 500,
                        paddingX: "0",
                        _hover: {
                            background: "none"
                        },
                        _focus: {
                            border: "none"
                        },
                        onClick: function() {
                            return setCurrentStep(ECurrentStep.VERIFICATION);
                        },
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                        colorScheme: "teal",
                        lineHeight: 6,
                        onClick: onSubmit,
                        isLoading: isLoading,
                        children: "Send"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ForgotPassword = (ForgotPassword);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chakra-ui-form-control.esm.js + 1 modules
var chakra_ui_form_control_esm = __webpack_require__(3789);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(4612);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/CustomFormPhoneInput/index.tsx







var CustomFormPhoneInput = function(props) {
    var onPastePhoneInput = function onPastePhoneInput(event) {
        var clipboardData = event.clipboardData;
        var pastedPhoneNumber = clipboardData.getData("Text").replace(/\n/g, "");
        if (pastedPhoneNumber.startsWith("+1")) {
            var phoneNumber = (0,utils_common/* formatUSPhoneNumber */.uX)(pastedPhoneNumber);
            setValue("phoneNumber", phoneNumber);
        }
    };
    var isAutoFocus = props.isAutoFocus;
    var ref = (0,index_esm/* useFormContext */.Gc)(), control = ref.control, setValue = ref.setValue;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
        name: "phoneNumber",
        control: control,
        rules: {
            required: "Phone number is required",
            pattern: {
                value: common/* PHONE_NUMBER_PATTERN */.Cx,
                message: "Invalid Phone Number"
            }
        },
        render: function(param) {
            var _field = param.field, onChange = _field.onChange, value = _field.value;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* Input */.II, {
                autoFocus: isAutoFocus,
                height: {
                    base: 12,
                    lg: 10
                },
                as: react_number_format_es/* default */.Z,
                value: value,
                onChange: onChange,
                format: "(###) ###-####",
                placeholder: "(000) 000 - 0000",
                marginTop: "0 !important",
                onPaste: onPastePhoneInput
            });
        }
    });
};
/* harmony default export */ var components_CustomFormPhoneInput = (CustomFormPhoneInput);

// EXTERNAL MODULE: ./components/Icon/index.tsx
var Icon = __webpack_require__(11665);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/PersonalInformationStep/components/LoginOption/constants.ts
var THIRD_PARTY_AUTHENTICATION_ENDPOINT = "/auth/third-party/google";

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/PersonalInformationStep/components/LoginOption/index.tsx





var LoginOption = function(props) {
    var handleClickLoginOption = function handleClickLoginOption() {
        typeof setLoginType === "function" && setLoginType(loginType);
        if (loginType === ELoginType.GOOGLE) {
            window.location.href = "".concat("https://api.livehomeroom.com/").concat(THIRD_PARTY_AUTHENTICATION_ENDPOINT);
        }
    };
    var loginType = props.loginType, icon = props.icon, content = props.content, setLoginType = props.setLoginType, disabled = props.disabled;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_button_esm/* Button */.zx, {
        onClick: handleClickLoginOption,
        isFullWidth: true,
        borderRadius: "6px",
        border: "1px solid",
        borderColor: "gray.300",
        fontWeight: 500,
        background: "none",
        justifyContent: "flex-start",
        _hover: {
            background: "none"
        },
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                iconName: icon,
                size: 20
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                marginLeft: 2,
                color: "gray.700",
                lineHeight: 6,
                children: content
            })
        ]
    });
};
/* harmony default export */ var components_LoginOption = (LoginOption);

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/PersonalInformationStep/index.tsx









var PersonalInformationStep = function(props) {
    var loginType = props.loginType, setLoginType = props.setLoginType;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var errorMessage = get_default()(errors, "".concat(loginType, ".message"), "");
    var isLoginWithPhoneNumber = loginType === ELoginType.PHONE_NUMBER;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalContent */.hz, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalHeader */.xB, {
                fontSize: "lg",
                color: "gray.800",
                fontWeight: 500,
                lineHeight: 7,
                borderBottom: "1px",
                borderColor: "gray.200",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        children: "Login to HomeRoom"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalCloseButton */.ol, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalBody */.fe, {
                fontWeight: 500,
                paddingY: 6,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_form_control_esm/* FormControl */.NI, {
                    isInvalid: !!errorMessage,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            fontWeight: 600,
                            fontSize: "lg",
                            height: 7,
                            lineHeight: 7,
                            children: "Welcome to HomeRoom!"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                            marginTop: 6,
                            marginBottom: 2,
                            color: "gray.700",
                            children: [
                                "Get started with your ",
                                isLoginWithPhoneNumber ? "phone number" : "e-mail"
                            ]
                        }),
                        isLoginWithPhoneNumber ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_CustomFormPhoneInput, {
                            isAutoFocus: true
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                            autoFocus: true,
                            placeholder: "Enter your E-mail",
                            height: {
                                base: 12,
                                lg: 10
                            }
                        }, register("email", {
                            pattern: {
                                value: common/* EMAIL_PATTERN */.QI,
                                message: "Invalid E-mail"
                            },
                            required: "E-mail is required"
                        }))),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_form_control_esm/* FormErrorMessage */.J1, {
                            marginTop: "5px",
                            children: errorMessage
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                            isFullWidth: true,
                            colorScheme: "teal",
                            marginTop: 6,
                            isLoading: isSubmitting,
                            type: "submit",
                            lineHeight: 6,
                            children: "Continue"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                align: "center",
                marginBottom: 6,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Divider */.iz, {
                        borderColor: "gray.500"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        paddingX: 6,
                        color: "gray.500",
                        fontWeight: 400,
                        children: "Or"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Divider */.iz, {
                        borderColor: "gray.500"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalFooter */.mz, {
                flexDirection: "column",
                paddingTop: 0,
                paddingBottom: 6,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                    spacing: 4,
                    width: "full",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_LoginOption, {
                            loginType: ELoginType.FACEBOOK,
                            icon: "circleFacebook.svg",
                            content: "Continue with Facebook",
                            disabled: true
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_LoginOption, {
                            loginType: ELoginType.GOOGLE,
                            icon: "google.svg",
                            content: "Continue with Google"
                        }),
                        isLoginWithPhoneNumber ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_LoginOption, {
                            loginType: ELoginType.EMAIL,
                            icon: "email.svg",
                            content: "Continue with E-mail",
                            setLoginType: setLoginType
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_LoginOption, {
                            loginType: ELoginType.PHONE_NUMBER,
                            icon: "phone.svg",
                            content: "Continue with Phone number",
                            setLoginType: setLoginType
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_PersonalInformationStep = (PersonalInformationStep);

// EXTERNAL MODULE: ./components/PasswordField/index.tsx
var PasswordField = __webpack_require__(84922);
// EXTERNAL MODULE: ./routes/index.ts + 2 modules
var routes = __webpack_require__(1179);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/ResetPassword/index.tsx














var ResetPassword = function(props) {
    var handleResetPassword = function handleResetPassword() {
        handleSubmit(onSubmit)();
    };
    var ref;
    var setCurrentStep = props.setCurrentStep, setLoginType = props.setLoginType;
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), control = ref1.control, handleSubmit = ref1.handleSubmit;
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var router = (0,next_router.useRouter)();
    var newPassword = (0,index_esm/* useWatch */.qo)({
        control: control,
        name: "newPassword"
    });
    var confirmPassword = (0,index_esm/* useWatch */.qo)({
        control: control,
        name: "newPassword"
    });
    var resetPasswordToken = String(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.resetPassword);
    function onSubmit() {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setIsLoading(true);
                        _ctx.next = 4;
                        return (0,authenticate/* resetPassword */.c0)({
                            newPassword: newPassword,
                            confirmPassword: confirmPassword,
                            resetPasswordToken: resetPasswordToken
                        });
                    case 4:
                        result = _ctx.sent;
                        if (!result) {
                            react_toastify_esm/* toast.error */.Am.error("Something wrong happened");
                        } else {
                            react_toastify_esm/* toast.success */.Am.success("Reset password successfully");
                        }
                        setIsLoading(false);
                        router.push(routes/* default.home.value */.Z.home.value);
                        setCurrentStep(ECurrentStep.PERSONAL_INFORMATION);
                        setLoginType(ELoginType.EMAIL);
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,error/* handleError */.S)(_ctx.t0, "components/pages/DetailPage/components/SideBar/components/LoginModal/components/ResetPassword/index.tsx", "onSubmit");
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return _onSubmit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalContent */.hz, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalHeader */.xB, {
                fontSize: "lg",
                color: "gray.800",
                fontWeight: 500,
                lineHeight: 7,
                borderBottom: "1px",
                borderColor: "gray.200",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        children: "Reset Password"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalCloseButton */.ol, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalBody */.fe, {
                fontWeight: 500,
                paddingY: 6,
                paddingX: {
                    base: 4,
                    md: 6
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                    alignItems: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            color: "gray.700",
                            marginBottom: 4,
                            children: "Please provide your new password"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PasswordField/* default */.Z, {
                            name: "newPassword",
                            label: "New Password",
                            pattern: {
                                value: common/* PASSWORD_PATTERN */.mS,
                                message: "Please enter a valid password"
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                            alignItems: "flex-start",
                            color: "gray.500",
                            fontSize: "14px",
                            fontWeight: 400,
                            spacing: 0,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                    as: "li",
                                    children: "Upper and lower case letters"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                    as: "li",
                                    children: "At least 8 characters"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                    as: "li",
                                    children: "Must contain digits"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalFooter */.mz, {
                paddingTop: 4,
                paddingBottom: 4,
                borderTop: "1px",
                borderColor: "gray.200",
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                    colorScheme: "teal",
                    lineHeight: 6,
                    onClick: handleResetPassword,
                    isLoading: isLoading,
                    children: "Reset Password"
                })
            })
        ]
    });
};
/* harmony default export */ var components_ResetPassword = (ResetPassword);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/chakra-ui-checkbox.esm.js + 2 modules
var chakra_ui_checkbox_esm = __webpack_require__(34530);
// EXTERNAL MODULE: ./enums/user/index.ts
var user = __webpack_require__(75013);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/SignUpStep/signUpStep.styles.ts

var SignUpContent = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_modal_esm/* ModalContent */.hz, {
    baseStyle: {
        height: {
            base: "100%",
            md: "unset"
        }
    }
});
var SignUpHeader = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_modal_esm/* ModalHeader */.xB, {
    baseStyle: {
        fontSize: "lg",
        color: "gray.800",
        fontWeight: 500,
        lineHeight: 7,
        borderBottom: "1px",
        borderColor: "gray.200"
    }
});
var SignUpBody = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_modal_esm/* ModalBody */.fe, {
    baseStyle: {
        fontWeight: 500,
        paddingY: 6,
        paddingX: {
            base: 4,
            md: 6
        },
        display: {
            base: "flex",
            md: "block"
        },
        flex: {
            base: 1
        },
        flexDirection: "column",
        overflowY: "auto"
    }
});

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/SignUpStep/utils.ts
function validatePassword(password) {
    if (password.length < 8) {
        return "Password must be at least 8 characters long.";
    }
    if (!/[0-9]/.test(password)) {
        return "Password must contain at least one number.";
    }
    if (!/[a-z]/.test(password)) {
        return "Password must contain at least one lowercase letter.";
    }
    if (!/[A-Z]/.test(password)) {
        return "Password must contain at least one uppercase letter.";
    }
    return true;
}

// EXTERNAL MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/SignUpStep/styles.module.scss
var styles_module = __webpack_require__(72075);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/SignUpStep/index.tsx




















var SignUpStep = function(props) {
    var handleSignup = function handleSignup() {
        handleSubmit(onSubmit)();
    };
    var loginType = props.loginType, setCurrentStep = props.setCurrentStep;
    var ref = (0,index_esm/* useFormContext */.Gc)(), handleSubmit = ref.handleSubmit, control = ref.control, errors = ref.formState.errors;
    var ref1 = (0,react.useState)(false), isAgree = ref1[0], setIsAgree = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var isNameInvalid = (errors === null || errors === void 0 ? void 0 : errors.firstName) || (errors === null || errors === void 0 ? void 0 : errors.lastName);
    var isMobile = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.MD */.yE.MD);
    var isTablet = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.LG */.yE.LG);
    function onSubmit(formData) {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(formData) {
            var fullName, ref, ref1, userData, newUser, ref2, errorMessage, ref3;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setIsLoading(true);
                        fullName = (0,utils_common/* getFullName */.Pp)(formData === null || formData === void 0 ? void 0 : formData.firstName, formData === null || formData === void 0 ? void 0 : formData.lastName);
                        ;
                        userData = {
                            name: fullName,
                            firstName: formData === null || formData === void 0 ? void 0 : formData.firstName,
                            lastName: formData === null || formData === void 0 ? void 0 : formData.lastName,
                            email: (ref = formData === null || formData === void 0 ? void 0 : formData.email) !== null && ref !== void 0 ? ref : "",
                            phoneNumber: (0,utils_common/* getRawUSPhoneNumber */.vM)(formData === null || formData === void 0 ? void 0 : formData.phoneNumber),
                            role: user/* ERole.USER */.S.USER,
                            accountType: user/* EAccountType.APPLICANT */.k.APPLICANT,
                            password: (ref1 = formData === null || formData === void 0 ? void 0 : formData.password) !== null && ref1 !== void 0 ? ref1 : ""
                        };
                        _ctx.next = 7;
                        return (0,authenticate/* signup */.IU)(userData);
                    case 7:
                        newUser = _ctx.sent;
                        react_toastify_esm/* toast.success */.Am.success("Signup Successfully");
                        if (!(loginType === ELoginType.EMAIL || ELoginType.PHONE_NUMBER)) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 12;
                        return (0,authenticate/* verifyEmail */.lm)(newUser);
                    case 12:
                        setCurrentStep(ECurrentStep.EMAIL_VERIFICATION);
                        return _ctx.abrupt("return");
                    case 14:
                        _ctx.next = 22;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        errorMessage = "Signup failed.";
                        if ((ref2 = _ctx.t0) === null || ref2 === void 0 ? void 0 : ref2.message) {
                            ;
                            errorMessage += " ".concat((ref3 = _ctx.t0) === null || ref3 === void 0 ? void 0 : ref3.message);
                        }
                        react_toastify_esm/* toast.error */.Am.error(errorMessage);
                    case 22:
                        _ctx.prev = 22;
                        setIsLoading(false);
                        return _ctx.finish(22);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    16,
                    22,
                    25
                ]
            ]);
        }));
        return _onSubmit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SignUpContent, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SignUpHeader, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        children: "Login to HomeRoom"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalCloseButton */.ol, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SignUpBody, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                        marginBottom: 2,
                        color: "gray.700",
                        children: [
                            "Hello newcomer\xa0",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                iconName: "hello-newcommer.svg",
                                size: 16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        color: "gray.700",
                        children: "Please enter the information to finish signing up."
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                        spacing: 6,
                        marginBottom: 0,
                        marginX: "auto",
                        width: "full",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                spacing: 4,
                                width: "full",
                                marginTop: 6,
                                marginBottom: isNameInvalid ? 6 : 0,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                                        height: isTablet ? "48px" : "40px",
                                        width: "calc((100% - 24px) / 2)",
                                        className: (styles_module_default()).inputContainer,
                                        name: "firstName",
                                        label: "Your Name",
                                        placeholder: "First Name",
                                        autoComplete: "off"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                                        height: isTablet ? "48px" : "40px",
                                        width: "calc((100% - 24px) / 2)",
                                        className: (styles_module_default()).inputContainer,
                                        name: "lastName",
                                        label: "Last Name",
                                        placeholder: "Last Name",
                                        hideLabel: true,
                                        autoComplete: "off"
                                    })
                                ]
                            }),
                            loginType === ELoginType.PHONE_NUMBER ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                                height: isTablet ? "48px" : "40px",
                                name: "email",
                                label: "Your Email Address",
                                placeholder: "Enter Your Email",
                                type: "email",
                                autoComplete: "off"
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                                name: "phoneNumber",
                                label: "Your Phone Number",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_CustomFormPhoneInput, {})
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PasswordField/* default */.Z, {
                                height: isTablet ? "48px" : "40px",
                                hasInfoIcon: true,
                                validate: validatePassword
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                                name: "confirm",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
                                    name: "confirm",
                                    control: control,
                                    rules: {
                                        required: "You must meet the requirement to continue."
                                    },
                                    render: function(param) {
                                        var onChange = param.field.onChange;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_checkbox_esm/* Checkbox */.XZ, {
                                            className: (styles_module_default()).confirmCheckbox,
                                            colorScheme: "teal",
                                            isChecked: isAgree,
                                            onChange: function(event) {
                                                setIsAgree(event.target.checked);
                                                onChange(event.target.checked);
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                                lineHeight: 5,
                                                color: "gray.700",
                                                fontSize: "sm",
                                                fontWeight: 400,
                                                children: [
                                                    "By selecting Complete, I agree to HomeRoom\u2019s\xa0",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                                                        href: "#",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                                            as: "b",
                                                            _hover: {
                                                                textDecoration: "underline"
                                                            },
                                                            children: "Term of service\xa0"
                                                        })
                                                    }),
                                                    "and the\xa0",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                                                        href: "#",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                                            as: "b",
                                                            _hover: {
                                                                textDecoration: "underline"
                                                            },
                                                            children: "Privacy policy."
                                                        })
                                                    })
                                                ]
                                            })
                                        });
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            isMobile ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                width: "full",
                bottom: 4,
                paddingX: 4,
                marginBottom: 4,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                        colorScheme: "teal",
                        lineHeight: 6,
                        disabled: !isAgree,
                        onClick: handleSignup,
                        width: "full",
                        height: 12,
                        children: "Complete"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                        colorScheme: "teal",
                        variant: "link",
                        lineHeight: 6,
                        fontWeight: 500,
                        paddingX: "0",
                        onClick: function() {
                            return setCurrentStep(ECurrentStep.PERSONAL_INFORMATION);
                        },
                        width: "full",
                        height: 12,
                        children: "Back to options"
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalFooter */.mz, {
                paddingTop: 4,
                paddingBottom: 4,
                borderTop: "1px",
                borderColor: "gray.200",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                        colorScheme: "teal",
                        variant: "link",
                        lineHeight: 6,
                        fontWeight: 500,
                        paddingX: "0",
                        _hover: {
                            background: "none"
                        },
                        _focus: {
                            border: "none"
                        },
                        onClick: function() {
                            return setCurrentStep(ECurrentStep.PERSONAL_INFORMATION);
                        },
                        children: "Back to options"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                        colorScheme: "teal",
                        lineHeight: 6,
                        disabled: !isAgree,
                        onClick: handleSignup,
                        isLoading: isLoading,
                        children: "Complete"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_SignUpStep = (SignUpStep);

// EXTERNAL MODULE: ./node_modules/react-otp-input/lib/index.js
var lib = __webpack_require__(71470);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/VerificationStep/components/OTPField/OTPField.module.scss
var OTPField_module = __webpack_require__(63153);
var OTPField_module_default = /*#__PURE__*/__webpack_require__.n(OTPField_module);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/VerificationStep/components/OTPField/index.tsx













var OTP_NUMBER_INPUTS = 4;
var OTP_INPUT_ID = "otp-input";
var OTPField = function(props) {
    var setIsDisableContinueButton = props.setIsDisableContinueButton;
    var ref = (0,useStores/* useStores */.m)(), spinnerStore = ref.spinnerStore, authStore = ref.authStore;
    var control = (0,index_esm/* useFormContext */.Gc)().control;
    var ref1 = (0,react.useState)(""), currentOtp = ref1[0], setCurrentOtp = ref1[1];
    var phoneNumber = (0,index_esm/* useWatch */.qo)({
        name: "phoneNumber",
        control: control
    }) || "";
    var rawPhoneNumber = (0,utils_common/* getRawUSPhoneNumber */.vM)(phoneNumber);
    var ref2 = (0,react.useState)(false), invalidOtp = ref2[0], setInvalidOtp = ref2[1];
    (0,react.useEffect)(function() {
        if ((currentOtp === null || currentOtp === void 0 ? void 0 : currentOtp.length) === OTP_NUMBER_INPUTS) {
            verifyCode();
        }
    }, [
        currentOtp
    ]);
    function verifyCode() {
        return _verifyCode.apply(this, arguments);
    }
    function _verifyCode() {
        _verifyCode = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isValid;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        spinnerStore.showLoading();
                        _ctx.next = 4;
                        return authStore.verifyOtpToken(currentOtp, rawPhoneNumber);
                    case 4:
                        isValid = _ctx.sent;
                        if (isValid) {
                            setInvalidOtp(false);
                            setIsDisableContinueButton(false);
                        } else {
                            setInvalidOtp(true);
                            setIsDisableContinueButton(true);
                        }
                        spinnerStore.hideLoading();
                        _ctx.next = 13;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,error/* handleError */.S)(_ctx.t0, "components/pages/DetailPage/components/SideBar/components/LoginModal/components/VerificationStep/components/OTPField/index.tsx", "verifyCode()");
                        spinnerStore.hideLoading();
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return _verifyCode.apply(this, arguments);
    }
    function resendCode() {
        return _resendCode.apply(this, arguments);
    }
    function _resendCode() {
        _resendCode = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return authStore.requestOtpToken(rawPhoneNumber);
                    case 3:
                        react_toastify_esm/* toast.success */.Am.success("OTP has been sent to your phone number.");
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        react_toastify_esm/* toast.error */.Am.error("The number ".concat(phoneNumber, " is not a valid phone number."));
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return _resendCode.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        spacing: 6,
        alignItems: "start",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                maxWidth: "350px",
                color: "gray.700",
                children: [
                    "Please enter 4 digit OTP code sent via SMS to",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                        as: "b",
                        children: [
                            " ",
                            rawPhoneNumber
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* HStack */.Ug, {
                spacing: 6,
                width: "full",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib/* default */.Z, {
                    value: currentOtp,
                    onChange: setCurrentOtp,
                    numInputs: OTP_NUMBER_INPUTS,
                    isInputNum: true,
                    shouldAutoFocus: true,
                    containerStyle: (OTPField_module_default()).otpInputContainer,
                    inputStyle: (OTPField_module_default()).otpInput,
                    focusStyle: (OTPField_module_default()).otpInputFocus,
                    "data-testid": OTP_INPUT_ID
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                as: "u",
                color: "blue.500",
                fontWeight: 400,
                cursor: "pointer",
                onClick: resendCode,
                children: "Resend OTP"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                display: invalidOtp ? "block" : "none",
                fontSize: "sm",
                color: "red.500",
                children: "That code is invalid or has expired, please try again"
            })
        ]
    });
};
/* harmony default export */ var components_OTPField = ((0,mobxreact_esm/* observer */.Pi)(OTPField));

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/components/VerificationStep/index.tsx
















var VerificationStep = function(props) {
    var handleLogin = function handleLogin() {
        handleSubmit(onSubmit)();
    };
    var authStore = (0,useStores/* useStores */.m)().authStore;
    var ref = (0,index_esm/* useFormContext */.Gc)(), handleSubmit = ref.handleSubmit, control = ref.control;
    var loginType = props.loginType, setCurrentStep = props.setCurrentStep, onClose = props.onClose;
    var isMobile = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.MD */.yE.MD);
    var isTablet = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.LG */.yE.LG);
    var ref1 = (0,react.useState)(true), isDisableContinueButton = ref1[0], setIsDisableContinueButton = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var userPassword = (0,index_esm/* useWatch */.qo)({
        name: "password",
        control: control
    }) || "";
    function onSubmit(data) {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var _phoneNumber, phoneNumber, _email, email, _password, password, rawPhoneNumber, websiteLoginResponse, websiteLoginResponse1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _phoneNumber = data.phoneNumber, phoneNumber = _phoneNumber === void 0 ? "" : _phoneNumber, _email = data.email, email = _email === void 0 ? "" : _email, _password = data.password, password = _password === void 0 ? "" : _password;
                        if (!(loginType === ELoginType.PHONE_NUMBER)) {
                            _ctx.next = 22;
                            break;
                        }
                        setIsLoading(true);
                        rawPhoneNumber = (0,utils_common/* getRawUSPhoneNumber */.vM)(phoneNumber);
                        _ctx.next = 6;
                        return authStore.loginWithPhoneNumber(rawPhoneNumber);
                    case 6:
                        websiteLoginResponse = _ctx.sent;
                        if (!(websiteLoginResponse === null || websiteLoginResponse === void 0 ? void 0 : websiteLoginResponse.userId)) {
                            _ctx.next = 19;
                            break;
                        }
                        if (websiteLoginResponse === null || websiteLoginResponse === void 0 ? void 0 : websiteLoginResponse.isEmailVerified) {
                            _ctx.next = 12;
                            break;
                        }
                        (0,authenticate/* verifyEmail */.lm)({
                            id: websiteLoginResponse === null || websiteLoginResponse === void 0 ? void 0 : websiteLoginResponse.userId
                        });
                        setCurrentStep(ECurrentStep.EMAIL_VERIFICATION);
                        return _ctx.abrupt("return");
                    case 12:
                        _ctx.next = 14;
                        return authStore.setAccessTokenWithPhoneNumber(rawPhoneNumber);
                    case 14:
                        setIsLoading(false);
                        react_toastify_esm/* toast.success */.Am.success("Login successfully!");
                        onClose();
                        _ctx.next = 20;
                        break;
                    case 19:
                        {
                            setIsLoading(false);
                            setCurrentStep(ECurrentStep.SIGN_UP);
                        }
                    case 20:
                        _ctx.next = 38;
                        break;
                    case 22:
                        if (!(loginType === ELoginType.EMAIL)) {
                            _ctx.next = 38;
                            break;
                        }
                        setIsLoading(true);
                        _ctx.next = 26;
                        return authStore.setAccessTokenWithEmail(email, password);
                    case 26:
                        websiteLoginResponse1 = _ctx.sent;
                        if (!((websiteLoginResponse1 === null || websiteLoginResponse1 === void 0 ? void 0 : websiteLoginResponse1.userId) && (websiteLoginResponse1 === null || websiteLoginResponse1 === void 0 ? void 0 : websiteLoginResponse1.token))) {
                            _ctx.next = 37;
                            break;
                        }
                        if (websiteLoginResponse1 === null || websiteLoginResponse1 === void 0 ? void 0 : websiteLoginResponse1.isEmailVerified) {
                            _ctx.next = 32;
                            break;
                        }
                        (0,authenticate/* verifyEmail */.lm)({
                            id: websiteLoginResponse1 === null || websiteLoginResponse1 === void 0 ? void 0 : websiteLoginResponse1.userId
                        });
                        setCurrentStep(ECurrentStep.EMAIL_VERIFICATION);
                        return _ctx.abrupt("return");
                    case 32:
                        setIsLoading(false);
                        react_toastify_esm/* toast.success */.Am.success("Login successfully!");
                        onClose();
                        _ctx.next = 38;
                        break;
                    case 37:
                        {
                            setIsLoading(false);
                            react_toastify_esm/* toast.error */.Am.error("Wrong password, please try again!");
                        }
                    case 38:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _onSubmit.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        if (loginType === ELoginType.EMAIL && userPassword) {
            setIsDisableContinueButton(false);
        }
    }, [
        loginType,
        userPassword
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalContent */.hz, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalHeader */.xB, {
                fontSize: "lg",
                color: "gray.800",
                fontWeight: 500,
                lineHeight: 7,
                borderBottom: "1px",
                borderColor: "gray.200",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        children: "Login to HomeRoom"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalCloseButton */.ol, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalBody */.fe, {
                fontWeight: 500,
                paddingY: 6,
                paddingX: {
                    base: 4,
                    md: 6
                },
                children: loginType === ELoginType.PHONE_NUMBER ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_OTPField, {
                    setIsDisableContinueButton: setIsDisableContinueButton
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                    alignItems: "start",
                    spacing: 6,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PasswordField/* default */.Z, {
                            height: isTablet ? "48px" : "40px",
                            autoFocus: true
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            as: "u",
                            color: "blue.500",
                            fontWeight: 400,
                            cursor: "pointer",
                            onClick: function() {
                                return setCurrentStep(ECurrentStep.FORGOT_PASSWORD);
                            },
                            children: "Forgot password?"
                        })
                    ]
                })
            }),
            isMobile ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                width: "full",
                bottom: 4,
                paddingX: 4,
                marginBottom: 4,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                        colorScheme: "teal",
                        lineHeight: 6,
                        onClick: handleLogin,
                        width: "full",
                        height: 12,
                        children: "Complete"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                        colorScheme: "teal",
                        variant: "link",
                        lineHeight: 6,
                        fontWeight: 500,
                        paddingX: "0",
                        onClick: function() {
                            return setCurrentStep(ECurrentStep.PERSONAL_INFORMATION);
                        },
                        width: "full",
                        height: 12,
                        children: "Back to options"
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalFooter */.mz, {
                paddingTop: 4,
                paddingBottom: 4,
                borderTop: "1px",
                borderColor: "gray.200",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                        colorScheme: "teal",
                        variant: "link",
                        lineHeight: 6,
                        fontWeight: 500,
                        paddingX: "0",
                        _hover: {
                            background: "none"
                        },
                        _focus: {
                            border: "none"
                        },
                        onClick: function() {
                            return setCurrentStep(ECurrentStep.PERSONAL_INFORMATION);
                        },
                        children: "Back to options"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                        colorScheme: "teal",
                        lineHeight: 6,
                        onClick: handleLogin,
                        isDisabled: isDisableContinueButton,
                        isLoading: isLoading,
                        children: "Continue"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_VerificationStep = ((0,mobxreact_esm/* observer */.Pi)(VerificationStep));

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/SideBar/components/LoginModal/index.tsx


























var LoginModal = function(props) {
    var handleCloseModal = function handleCloseModal() {
        onClose();
        setCurrentStep(ECurrentStep.PERSONAL_INFORMATION);
    };
    var isOpen = props.isOpen, onClose = props.onClose, onOpen = props.onOpen, handleAfterAuth = props.handleAfterAuth, previousPhoneNumber = props.previousPhoneNumber, setApplicationValue = props.setApplicationValue;
    var authStore = (0,useStores/* useStores */.m)().authStore;
    var isLogin = authStore.isLogin, user = authStore.user;
    var isMobile = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.MD */.yE.MD);
    var ref = (0,react.useState)(ELoginType.PHONE_NUMBER), currentLoginType = ref[0], setCurrentLoginType = ref[1];
    var ref1 = (0,react.useState)(ECurrentStep.PERSONAL_INFORMATION), currentStep = ref1[0], setCurrentStep = ref1[1];
    var methods = (0,index_esm/* useForm */.cI)();
    var handleSubmit = methods.handleSubmit, setValue = methods.setValue, reset = methods.reset;
    var emailVerificationText = "Please check your email and follow the instruction to activate your account.\nIf you don\u2019t receive the email, check your Spam";
    var router = (0,next_router.useRouter)();
    function goToVerificationStep(data) {
        return _goToVerificationStep.apply(this, arguments);
    }
    function _goToVerificationStep() {
        _goToVerificationStep = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var _phoneNumber, phoneNumber, _email, email, rawPhoneNumber, isTestPhoneNumber, isValidUSPhoneNumber, response, websiteLoginResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _phoneNumber = data.phoneNumber, phoneNumber = _phoneNumber === void 0 ? "" : _phoneNumber, _email = data.email, email = _email === void 0 ? "" : _email;
                        _ctx.prev = 1;
                        rawPhoneNumber = (0,utils_common/* getRawUSPhoneNumber */.vM)(phoneNumber);
                        isTestPhoneNumber = rawPhoneNumber === constants/* TEST_PHONE_NUMBER */.UZ;
                        isValidUSPhoneNumber = common/* RAW_US_PHONE_NUMBER_PATTERN.test */.nB.test(rawPhoneNumber);
                        if (!(currentLoginType === ELoginType.PHONE_NUMBER)) {
                            _ctx.next = 33;
                            break;
                        }
                        if (isValidUSPhoneNumber) {
                            _ctx.next = 10;
                            break;
                        }
                        {
                            react_toastify_esm/* toast.error */.Am.error("The number ".concat(phoneNumber, " is not a valid phone number."));
                        }
                        _ctx.next = 31;
                        break;
                    case 10:
                        if (isTestPhoneNumber) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 13;
                        return authStore.requestOtpToken(rawPhoneNumber);
                    case 13:
                        setCurrentStep(ECurrentStep.VERIFICATION);
                        _ctx.next = 31;
                        break;
                    case 16:
                        _ctx.next = 18;
                        return authStore.loginWithPhoneNumber(rawPhoneNumber);
                    case 18:
                        response = _ctx.sent;
                        if (!(response === null || response === void 0 ? void 0 : response.userId)) {
                            _ctx.next = 30;
                            break;
                        }
                        if (response === null || response === void 0 ? void 0 : response.isEmailVerified) {
                            _ctx.next = 24;
                            break;
                        }
                        (0,authenticate/* verifyEmail */.lm)({
                            id: response === null || response === void 0 ? void 0 : response.userId
                        });
                        setCurrentStep(ECurrentStep.EMAIL_VERIFICATION);
                        return _ctx.abrupt("return");
                    case 24:
                        _ctx.next = 26;
                        return authStore.setAccessTokenWithPhoneNumber(rawPhoneNumber);
                    case 26:
                        react_toastify_esm/* toast.success */.Am.success("Login successfully!");
                        onClose();
                        _ctx.next = 31;
                        break;
                    case 30:
                        {
                            setCurrentStep(ECurrentStep.SIGN_UP);
                        }
                    case 31:
                        _ctx.next = 38;
                        break;
                    case 33:
                        if (!(currentLoginType === ELoginType.EMAIL)) {
                            _ctx.next = 38;
                            break;
                        }
                        _ctx.next = 36;
                        return authStore.loginWithEmail(email);
                    case 36:
                        websiteLoginResponse = _ctx.sent;
                        if (websiteLoginResponse === null || websiteLoginResponse === void 0 ? void 0 : websiteLoginResponse.userId) {
                            setCurrentStep(ECurrentStep.VERIFICATION);
                        } else {
                            setCurrentStep(ECurrentStep.SIGN_UP);
                        }
                    case 38:
                        _ctx.next = 44;
                        break;
                    case 40:
                        _ctx.prev = 40;
                        _ctx.t0 = _ctx["catch"](1);
                        react_toastify_esm/* toast.error */.Am.error("The number ".concat(phoneNumber, " is not a valid phone number."));
                        (0,error/* handleError */.S)(_ctx.t0, "components/pages/DetailPage/components/SideBar/components/LoginModal/index.tsx", "goToVerificationStep()");
                    case 44:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    40
                ]
            ]);
        }));
        return _goToVerificationStep.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        if (currentStep === ECurrentStep.COMPLETE || currentStep === ECurrentStep.EMAIL_VERIFICATION) {
            var timer = setTimeout(function() {
                if (currentStep === ECurrentStep.EMAIL_VERIFICATION) {
                    return;
                }
                handleCloseModal();
            }, 3000);
            typeof handleAfterAuth === "function" && handleAfterAuth();
            return function() {
                return clearTimeout(timer);
            };
        }
        return function() {};
    }, [
        currentStep,
        isLogin
    ]);
    (0,react.useEffect)(function() {
        if (previousPhoneNumber) {
            setValue("phoneNumber", previousPhoneNumber);
        }
    }, [
        previousPhoneNumber
    ]);
    (0,react.useEffect)(function() {
        if (isLogin) {
            reset();
            typeof setApplicationValue === "function" && setApplicationValue("phoneNumber", "");
        }
    }, [
        isLogin
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.resetPassword) {
            onOpen();
            setCurrentStep(ECurrentStep.RESET_PASSWORD);
        }
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        // *INFO: handle sign up after login with google account
        if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.isSignUp) {
            reset((0,_object_spread/* default */.Z)({}, user));
            onOpen();
            setCurrentStep(ECurrentStep.SIGN_UP);
            setCurrentLoginType(ELoginType.EMAIL);
        }
    }, []);
    // * INFO: use handleSubmit instead of passing goToVerificationStep as a props to verify valid phoneNumber or email
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* Modal */.u_, {
        isOpen: isOpen,
        onClose: handleCloseModal,
        size: isMobile ? "full" : "md",
        isCentered: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_system_esm/* chakra.form */.m$.form, {
                width: "full",
                onSubmit: handleSubmit(goToVerificationStep),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalOverlay */.ZA, {}),
                    currentStep === ECurrentStep.PERSONAL_INFORMATION && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PersonalInformationStep, {
                        loginType: currentLoginType,
                        setLoginType: setCurrentLoginType
                    }),
                    currentStep === ECurrentStep.VERIFICATION && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_VerificationStep, {
                        loginType: currentLoginType,
                        setCurrentStep: setCurrentStep,
                        onClose: handleCloseModal
                    }),
                    currentStep === ECurrentStep.SIGN_UP && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_SignUpStep, {
                        loginType: currentLoginType,
                        setCurrentStep: setCurrentStep
                    }),
                    currentStep === ECurrentStep.FORGOT_PASSWORD && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ForgotPassword, {
                        setCurrentStep: setCurrentStep,
                        setLoginType: setCurrentLoginType
                    }),
                    currentStep === ECurrentStep.RESET_PASSWORD && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ResetPassword, {
                        setCurrentStep: setCurrentStep,
                        setLoginType: setCurrentLoginType
                    }),
                    currentStep === ECurrentStep.COMPLETE && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_CompleteScreen, {}),
                    currentStep === ECurrentStep.EMAIL_VERIFICATION && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_CompleteScreen, {
                        bodyText: emailVerificationText
                    })
                ]
            })
        }))
    });
};
/* harmony default export */ var components_LoginModal = ((0,mobxreact_esm/* observer */.Pi)(LoginModal));


/***/ }),

/***/ 63516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RS": function() { return /* binding */ roommateDescriptionList; },
/* harmony export */   "UZ": function() { return /* binding */ TEST_PHONE_NUMBER; },
/* harmony export */   "i7": function() { return /* binding */ AMENITIES_ICON_MAP; },
/* harmony export */   "sO": function() { return /* binding */ defaultAmenities; },
/* harmony export */   "yH": function() { return /* binding */ MATTERPORT_DOMAIN; }
/* harmony export */ });
/* unused harmony export helperSMSLink */
var defaultAmenities = {
    title: "Additional Monthly amenities and Service Fee ($140/mo) includes:",
    utilityFee: "Flat rate utility fee",
    maintenance: "24/7 Emergency Maintenance",
    internet: "High-speed, unlimited WiFi",
    laundry: "In-house laundry",
    maidService: "Maid Service",
    smartTV: '50" Smart TV',
    lawnCare: "Lawn Care",
    events: "Exclusive Community and Events",
    homeRoomApp: "Custom-built HomeRoom App",
    creditScore: "Increase your credit score with each rent payment"
};
var helperSMSLink = "sms:+18162031186";
var roommateDescriptionList = [
    "Hi! We're looking for someone who enjoys a pleasant and laid back roomate dynamic. We're a group of people with different professions and hobbies, would love to find someone interesting to add to the mix!  A + if you like to go hiking or walks, enjoy sports or athletics or grab dinner.",
    "We\u2019re a mix of later-stage students and professionals. We were randomly paired together as roommates and it's worked out great. Looking maintain the chill and respectful dynamic we have established. Let's meet if that sounds like you!",
    "Eclectic group of nice, mature people here! We're all working professionals but as soon as we come home we like to chill, relax and chat about our days. Looking for someone who appreciates a moderately social but laid back vibe.",
    "We are a group of individuals in various age groups looking for someone who is clean, responsible, friendly and chill.\n  Looking forward to meeting you!",
    "We\u2019re a group of professionals and creative folks. Very chill, respectful and positive vibes. Cool with having friends over time to time. Prefer a clean person who helps out when needed."
];
var TEST_PHONE_NUMBER = "+15555555555";
var AMENITIES_ICON_MAP = {
    utilityFee: "fee.svg",
    maintenance: "maintenance.svg",
    internet: "wifi.svg",
    laundry: "washing_machine.svg",
    maidService: "clean.svg",
    smartTV: "TV.svg",
    lawnCare: "lawn.svg",
    events: "event.svg",
    homeRoomApp: "app.svg",
    creditScore: "payment.svg"
};
var MATTERPORT_DOMAIN = "matterport";


/***/ }),

/***/ 88501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cx": function() { return /* binding */ PHONE_NUMBER_PATTERN; },
/* harmony export */   "Ge": function() { return /* binding */ NAME_PATTERN; },
/* harmony export */   "H6": function() { return /* binding */ YEAR_PATTERN; },
/* harmony export */   "Jp": function() { return /* binding */ NAME_WITH_NUMBER_PATTERN; },
/* harmony export */   "QI": function() { return /* binding */ EMAIL_PATTERN; },
/* harmony export */   "Vo": function() { return /* binding */ DATE_OF_BIRTH_PATTERN; },
/* harmony export */   "ZI": function() { return /* binding */ MONTHLY_INCOME_PATTERN; },
/* harmony export */   "c8": function() { return /* binding */ MONTH_PATTERN; },
/* harmony export */   "fY": function() { return /* binding */ ZIP_CODE_PATTERN; },
/* harmony export */   "kc": function() { return /* binding */ RAW_PHONE_NUMBER_PATTERN; },
/* harmony export */   "mS": function() { return /* binding */ PASSWORD_PATTERN; },
/* harmony export */   "nB": function() { return /* binding */ RAW_US_PHONE_NUMBER_PATTERN; },
/* harmony export */   "rq": function() { return /* binding */ DAY_PATTERN; },
/* harmony export */   "v8": function() { return /* binding */ NUMBER_WITH_COMMA_PATTERN; },
/* harmony export */   "zC": function() { return /* binding */ NUMBER_PATTERN; }
/* harmony export */ });
var ZIP_CODE_PATTERN = /(^\d{4,5}$)|(^\d{5}-\d{4}$)/;
var PHONE_NUMBER_PATTERN = /^\(\d{3}\) \d{3}-\d{4}$/;
var RAW_PHONE_NUMBER_PATTERN = /^\+?1?\s*\(?-*\.*(\d{3})\)?\.*-*\s*(\d{3})\.*-*\s*(\d{4})$/;
var NAME_PATTERN = /^[a-zA-Z\u00C0-\u017F\s-']+$/;
var EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
var NUMBER_PATTERN = /^(\$)?(\d+)(\.\d+)?$/;
var NUMBER_WITH_COMMA_PATTERN = /\B(?=(\d{3})+(?!\d))/g;
var NAME_WITH_NUMBER_PATTERN = /^[a-zA-Z0-9\u00C0-\u017F\s-']+$/;
var RAW_US_PHONE_NUMBER_PATTERN = /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/;
//* INFO: validate password: upper and lower case letters, at least 8 characters and must contain digits
var PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
//* INFO: validate income: allow currency characters $ at the beginning of the string or not and allow decimal numbers with any digits after the decimal point
var MONTHLY_INCOME_PATTERN = /^(\$)?(\d+)(\.\d+)?$/;
//*INFO: validate day: between 1 and 31
var DAY_PATTERN = /^(0[1-9]|[12][0-9]|3[01])$/;
//*INFO: validate month: between 1 and 12
var MONTH_PATTERN = /^(0[1-9]|1[012])$/;
//*INFO: validate year: between 1900 and 2099
var YEAR_PATTERN = /^(19|20)\d\d$/;
//* INFO Check if dateOfBirth is valid
var DATE_OF_BIRTH_PATTERN = /^02[- /.]29[- /.]((19|20)([2468][048]|[13579][26]|0[48])|2000)|((0[469]|11)[- /.](0[1-9]|[12][0-9]|30)[- /.](19|20)[0-9]{2}|(0[13578]|1[02])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)[0-9]{2}|02[- /.](0[1-9]|1[0-9]|2[0-8])[- /.](19|20)[0-9]{2})$/;


/***/ }),

/***/ 9322:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var EFeatureFlags;
(function(EFeatureFlags) {
    EFeatureFlags["WEBSITE_LOGIN"] = "website-login";
    EFeatureFlags["WEBSITE_LISTING_PAGE_ENTIRE_HOUSE"] = "website-listing-page-entire-house";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_V2"] = "application-form-v2";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_OTP_VERIFY"] = "application-form-otp-verify";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_CRS_CHECK"] = "application-form-crs-check";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_SIGN_AGREEMENT"] = "application-form-sign-agreement";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_PAYMENT"] = "application-form-payment";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_ROOMMATE_SMS"] = "application-form-roommate-sms";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_CHOOSE_UNIT_ON_SIDEBAR_47"] = "application-form-choose-unit-in-sidebar-47";
    EFeatureFlags["WEBSITE_PRICING_TABLE_WIFI"] = "website-pricing-table-wifi-50";
    EFeatureFlags["WEBSITE_CHATBOX"] = "website-chatbox-50";
    EFeatureFlags["OWNER_PORTAL_LOGIN"] = "owner-portal-login";
    EFeatureFlags["CMS"] = "cms";
    EFeatureFlags["OWNER_PORTAL"] = "owner-portal";
    EFeatureFlags["OWNER_PORTAL_FINANCIAL"] = "owner-portal-financial";
    EFeatureFlags["OWNER_PORTAL_LEASE"] = "owner-portal-lease";
    EFeatureFlags["OWNER_PORTAL_REPAIR"] = "owner-portal-repair";
    EFeatureFlags["CMS_PAYMENT_LIST"] = "cms-payment-list";
    EFeatureFlags["CMS_UNIT_MAIN_PHOTO"] = "cms-unit-main-photo";
    EFeatureFlags["PRICING_TABLE"] = "pricing-table";
})(EFeatureFlags || (EFeatureFlags = {}));
/* harmony default export */ __webpack_exports__["Z"] = (EFeatureFlags);


/***/ }),

/***/ 60431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OL": function() { return /* binding */ NavLink; },
/* harmony export */   "qd": function() { return /* binding */ EZIndexLayer; },
/* harmony export */   "yE": function() { return /* binding */ EBreakPoint; }
/* harmony export */ });
/* unused harmony export ThemeMode */
var ThemeMode;
(function(ThemeMode) {
    ThemeMode["LIGHT"] = "white";
    ThemeMode["DARK"] = "black";
})(ThemeMode || (ThemeMode = {}));
var NavLink;
(function(NavLink) {
    NavLink["LINK"] = "link";
    NavLink["BUTTON"] = "button";
    NavLink["DROPDOWN"] = "dropdown";
    NavLink["EMPTY_DROPDOWN"] = "empty-dropdown";
})(NavLink || (NavLink = {}));
var EZIndexLayer;
(function(EZIndexLayer) {
    EZIndexLayer[EZIndexLayer["BASE"] = 0] = "BASE";
    EZIndexLayer[EZIndexLayer["UPPER"] = 1] = "UPPER";
    EZIndexLayer[EZIndexLayer["INPUT_DROPDOWN"] = 1000] = "INPUT_DROPDOWN";
    EZIndexLayer[EZIndexLayer["OVER_INPUT_DROPDOWN"] = 1001] = "OVER_INPUT_DROPDOWN";
    EZIndexLayer[EZIndexLayer["CONTENT_VIEW"] = 1100] = "CONTENT_VIEW";
    EZIndexLayer[EZIndexLayer["WELCOME_BAR"] = 1150] = "WELCOME_BAR";
    EZIndexLayer[EZIndexLayer["FILTER_BAR"] = 1200] = "FILTER_BAR";
    EZIndexLayer[EZIndexLayer["NAV"] = 1300] = "NAV";
    EZIndexLayer[EZIndexLayer["OVER_CONTENT"] = 1150] = "OVER_CONTENT";
    EZIndexLayer[EZIndexLayer[// INFO: Follow z-index of chakra modal component
    // https://chakra-ui.com/docs/components/modal
    "MODAL"] = 1400] = "MODAL";
    EZIndexLayer[EZIndexLayer["OVERLAY"] = 1500] = "OVERLAY";
    EZIndexLayer[EZIndexLayer["TOAST"] = 9999] = "TOAST";
})(EZIndexLayer || (EZIndexLayer = {}));
var EBreakPoint;
(function(EBreakPoint) {
    EBreakPoint["BASE"] = "base";
    EBreakPoint["XS"] = "xs";
    EBreakPoint["SM"] = "sm";
    EBreakPoint["MD"] = "md";
    EBreakPoint["LG"] = "lg";
    EBreakPoint["XL"] = "xl";
})(EBreakPoint || (EBreakPoint = {}));


/***/ }),

/***/ 41894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var enums_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60431);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86229);



var getBreakPointValue = function(breakPoint) {
    switch(breakPoint){
        case enums_theme__WEBPACK_IMPORTED_MODULE_0__/* .EBreakPoint.XS */ .yE.XS:
            // INFO: using breakPoinTValue of sm because in this design we have min break point is sm
            return theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .breakPointValues.sm */ .g4.sm;
        case enums_theme__WEBPACK_IMPORTED_MODULE_0__/* .EBreakPoint.SM */ .yE.SM:
            return theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .breakPointValues.sm */ .g4.sm;
        case enums_theme__WEBPACK_IMPORTED_MODULE_0__/* .EBreakPoint.MD */ .yE.MD:
            return theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .breakPointValues.md */ .g4.md;
        case enums_theme__WEBPACK_IMPORTED_MODULE_0__/* .EBreakPoint.LG */ .yE.LG:
            return theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .breakPointValues.lg */ .g4.lg;
        case enums_theme__WEBPACK_IMPORTED_MODULE_0__/* .EBreakPoint.XL */ .yE.XL:
            return theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .breakPointValues.xl */ .g4.xl;
        default:
            return theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .breakPointValues.base */ .g4.base;
    }
};
var useBreakPoint = function(minBreakPoint, maxBreakPoint) {
    var minWidth = String(Number(getBreakPointValue(minBreakPoint).replace("px", "")) + 0.1) + "px";
    var settings = {
        minWidth: minWidth
    };
    if (maxBreakPoint) {
        settings.maxWidth = getBreakPointValue(maxBreakPoint);
    }
    var isMatched = (0,react_responsive__WEBPACK_IMPORTED_MODULE_2__.useMediaQuery)(settings);
    return isMatched;
};
/* harmony default export */ __webpack_exports__["Z"] = (useBreakPoint);


/***/ }),

/***/ 45949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useFeatureFlagValue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_unleash_flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68401);
/* harmony import */ var react_unleash_flags__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_unleash_flags__WEBPACK_IMPORTED_MODULE_1__);


function useFeatureFlagValue(name) {
    var singleEnvironment = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), isEnabled = ref[0], setIsEnabled = ref[1];
    var flagsClient = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(react_unleash_flags__WEBPACK_IMPORTED_MODULE_1__.FlagsContext);
    //* INFO: Flag name with environment
    var flagName = singleEnvironment ? name : "".concat("production", "-").concat(name);
    var flag = flagsClient ? flagsClient.getFlag(flagName) : undefined;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (flag) {
            //* INFO: Set flag value if fetched
            if (flag === null || flag === void 0 ? void 0 : flag.enabled) {
                setIsEnabled(true);
            } else {
                setIsEnabled(false);
            }
        }
    }, [
        flag
    ]);
    return {
        isEnabled: isEnabled,
        flagName: flagName
    };
};


/***/ }),

/***/ 19263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useStores; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var stores__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81436);


var storeContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(stores__WEBPACK_IMPORTED_MODULE_1__/* .rootStore */ .U);
var useStores = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(storeContext);
};


/***/ }),

/***/ 8650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46052);
/* harmony import */ var _emotion_is_prop_valid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79313);


function chakraShouldForwardProp(CkComponent, baseStyle) {
    return (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)(CkComponent, {
        shouldForwardProp: function(prop) {
            // *INFO:  don't forward Chakra's props
            var isChakraProp = !(0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .shouldForwardProp */ .x9)(prop);
            if (isChakraProp) return false;
            // *INFO: forward valid HTML props
            var isValidProp = (0,_emotion_is_prop_valid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(prop);
            if (isValidProp) return true;
            // *INFO: else, only forward `sample` prop
            return [
                "sample"
            ].includes(prop);
        },
        baseStyle: baseStyle
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (chakraShouldForwardProp);


/***/ }),

/***/ 2910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"styles_infoIcon__zntMo"};

/***/ }),

/***/ 72075:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"styles_inputContainer__M_a7k","confirmCheckbox":"styles_confirmCheckbox__mu7eR"};

/***/ }),

/***/ 63153:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"otpInputContainer":"OTPField_otpInputContainer___4NVX","otpInput":"OTPField_otpInput__K32Cl","otpInputFocus":"OTPField_otpInputFocus__GQOss"};

/***/ })

}]);